let productData = [
    {
        id: 'p1',
        name: 'Tackle Wheel 28"',
        sku: 'tw2814',
        description: 'Tackle wheel teaches players to adjust their angle in pursuit. Teach open field tackling without bodies. Reduce injuries by eliminating repetitions. Teaches players to wrap up in open field. 22 oz. coated vinyl in center and outside. 19 oz. coated vinyl on faces of wheel.',
        details: [
            'SKU: TW2814',
            '28" Outside diam. x 14" Inside diam.',
            '8" Thick.',
            'Rebond Foam.',
            'Weight: 21 lbs'
        ],
        options: [''],
        category: 'football',
        subCategory: 'training',
        urlCategory: 'football',
        urlSubCategory: 'training',
        image: "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Ftackle-wheel-tw2814-HQ1.jpg?alt=media&token=989abcd1-cf7a-4899-8176-a2d9db62ae6d",
        images: [
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Ftackle-wheel-tw2814-HQ1.jpg?alt=media&token=989abcd1-cf7a-4899-8176-a2d9db62ae6d",
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Ftackle-wheel-tw2814-HQ2.jpg?alt=media&token=3a37ddfa-efc0-4e3e-b63a-179a7d92b6b8",
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Ftackle-wheel-tw2814-HQ3.jpg?alt=media&token=c7a2216a-e88d-463a-9011-63311223dc26",
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Ftackle-wheels-HQ2.jpg?alt=media&token=505f449a-58db-4629-9ae0-701be6de40d5"
        ]
    },{
        id: 'p2',
        name: 'Tackle Wheel 36"',
        sku: 'tw3616',
        description: 'Tackle wheel teaches players to adjust their angle in pursuit. Teach open field tackling without bodies. Reduce injuries by eliminating repetitions. Teaches players to wrap up in open field. 22 oz. coated vinyl in center and outside. 19 oz. coated vinyl on faces of wheel.',
        details: [
            'SKU: TW3616',
            '36" Outside diam. x 16" Inside diam.',
            '8" Thick.',
            'Rebond Foam.',
            'Weight: 32 lbs'
        ],
        options: [''],
        category: 'football',
        subCategory: 'training',
        urlCategory: 'football',
        urlSubCategory: 'training',
        image: "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Ftackle-wheel-tw3616-HQ1.jpg?alt=media&token=d2aa663e-00d8-417b-871d-5680157f7d67",
        images: [
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Ftackle-wheel-tw3616-HQ1.jpg?alt=media&token=d2aa663e-00d8-417b-871d-5680157f7d67",
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Ftackle-wheels-HQ2.jpg?alt=media&token=505f449a-58db-4629-9ae0-701be6de40d5"
        ]
    },{
        id: 'p3',
        name: 'Tackle Wheel 42"',
        sku: 'tw4220',
        description: 'Tackle wheel teaches players to adjust their angle in pursuit. Teach open field tackling without bodies. Reduce injuries by eliminating repetitions. Teaches players to wrap up in open field. 22 oz. coated vinyl in center and outside. 19 oz. coated vinyl on faces of wheel.',
        details: [
            'SKU: TW4220',
            '42" Outside diam. x 20" Inside diam.',
            '9" Thick.',
            'PolyFoam.',
            'Weight: 15 lbs'
        ],
        options: [''],
        category: 'football',
        subCategory: 'training',
        urlCategory: 'football',
        urlSubCategory: 'training',
        image: "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Ftackle-wheel-tw4220-HQ1.jpg?alt=media&token=e3c61763-d46b-405f-965c-e80081f46f69",
        images: [
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Ftackle-wheel-tw4220-HQ1.jpg?alt=media&token=e3c61763-d46b-405f-965c-e80081f46f69",
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Ftackle-wheels-HQ2.jpg?alt=media&token=505f449a-58db-4629-9ae0-701be6de40d5"
        ]
    },{
        id: 'p4',
        name: 'Tackle Wheel 48"',
        sku: 'tw4825',
        description: 'Tackle wheel teaches players to adjust their angle in pursuit. Teach open field tackling without bodies. Reduce injuries by eliminating repetitions. Teaches players to wrap up in open field. 22 oz. coated vinyl in center and outside. 19 oz. coated vinyl on faces of wheel.',
        details: [
            'SKU: TW4825',
            '48" Outside diam. x 28" Inside diam.',
            '11" Thick.',
            'PolyFoam.',
            'Weight 21 lbs'
        ],
        options: [''],
        category: 'football',
        subCategory: 'training',
        urlCategory: 'football',
        urlSubCategory: 'training',
        image: "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Ftackle-wheel-tw4825-HQ1.jpg?alt=media&token=1a677c04-218e-4e5a-b425-739355ccc147",
        images: [
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Ftackle-wheel-tw4825-HQ1.jpg?alt=media&token=1a677c04-218e-4e5a-b425-739355ccc147",
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Ftackle-wheel-tw4825-HQ2.jpg?alt=media&token=fadb2ed4-272a-4742-b96b-dfb012cda332",
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Ftackle-wheels-HQ2.jpg?alt=media&token=505f449a-58db-4629-9ae0-701be6de40d5"
        ]
    },{
        id: 'p5',
        name: 'Tackle Wheel 54"',
        sku: 'tw5428',
        description: 'Tackle wheel teaches players to adjust their angle in pursuit. Teach open field tackling without bodies. Reduce injuries by eliminating repetitions. Teaches players to wrap up in open field. 22 oz. coated vinyl in center and outside. 19 oz. coated vinyl on faces of wheel.',
        details: [
            'SKU: TW5428',
            '54" Outside diam. x 28" Inside diam.',
            '12" Thick.',
            'PolyFoam.',
            'Weight: 24 lbs'
        ],
        options: [''],
        category: 'football',
        subCategory: 'training',
        urlCategory: 'football',
        urlSubCategory: 'training',
        image: "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Ftackle-wheel-tw5428-HQ1.jpg?alt=media&token=0035cdc9-dba7-498b-9fe9-ddd999199436",
        images: [
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Ftackle-wheel-tw5428-HQ1.jpg?alt=media&token=0035cdc9-dba7-498b-9fe9-ddd999199436",
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Ftackle-wheel-tw5428-HQ2.jpg?alt=media&token=3bec1b9e-a78c-4dfa-a6ad-449c387f3c72",
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Ftackle-wheel-tw5428-HQ3.jpg?alt=media&token=5836c95c-7fdb-46d8-9236-3e2c075d4e9e",
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Ftackle-wheels-HQ2.jpg?alt=media&token=505f449a-58db-4629-9ae0-701be6de40d5"
        ]
    },{
        id: 'p6',
        name: 'Tackle Wheel 60"',
        sku: 'tw6030',
        description: 'Tackle wheel teaches players to adjust their angle in pursuit. Teach open field tackling without bodies. Reduce injuries by eliminating repetitions. Teaches players to wrap up in open field. 22 oz. coated vinyl in center and outside. 19 oz. coated vinyl on faces of wheel.',
        details: [
            'SKU: TW6030',
            '60" Outside diam. x 30" Inside diam.',
            '12" Thick.',
            'PolyFoam.',
            'Weight: 27 lbs'
        ],
        options: [''],
        category: 'football',
        subCategory: 'training',
        urlCategory: 'football',
        urlSubCategory: 'training',
        image: "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Ftackle-wheel-tw6030-HQ1.jpg?alt=media&token=105c7595-8ea0-46d3-9d95-e1ba6c74fcec",
        images: [
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Ftackle-wheel-tw6030-HQ1.jpg?alt=media&token=105c7595-8ea0-46d3-9d95-e1ba6c74fcec",
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Ftackle-wheel-tw6030-HQ2.jpg?alt=media&token=20be0184-3abf-4253-a237-6d5ee68933e5",
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Ftackle-wheel-tw6030-HQ3.jpg?alt=media&token=8bd0ab92-a5d0-425c-a310-32468aa2ab11",
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Ftackle-wheels-HQ2.jpg?alt=media&token=505f449a-58db-4629-9ae0-701be6de40d5"
        ]
    },{
        id: 'p7',
        name: '2 Man Brute Sled',
        sku: '9712',
        description: "Individual components allow stations to be added as the need arises. Basic sleds can start with man capability and expanded as you desire. A 5 man sled can be easily broken down to a 2 and a 3 man sled. Sled skids are formed, not cut and welded. A 30 degree angle assures you of a smooth transition over your grass without chewing up the turf. Safe for artificial turf. Each brute sled pad's core is built from high density, 100 lb., impact resistant foam. Durable, 18 oz. vinyl covers are then double and triple stitched to withstand harsh weather and years of hard use. Choose from 6 pad styles and 11 colors for the brute sled. COACHES PLATFORM NOT INCLUDED.",
        details: [
            'SKU: 9712M',
            "Doesn't chew up grass or artificial turf",
            'Weight: 373 lbs'
        ],
        options: [
            '9712AP: Attack pad',
            '9712T: T pad',
            '9712M: Man pad',
            '9712V: V pad',
            '9712SM: Small man pad'
        ],
        category: 'football',
        subCategory: 'sleds',
        urlCategory: 'football',
        urlSubCategory: 'sleds',
        image: "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fbrute-sled-2man-9712-HQ.jpg?alt=media&token=013429a3-7a36-416c-a117-b2ceef40a66d",
        images: [
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fbrute-sled-2man-9712-HQ.jpg?alt=media&token=013429a3-7a36-416c-a117-b2ceef40a66d",
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fbrute-sled-2man-9712-HQ2.jpg?alt=media&token=9d3272e0-8e7e-489b-9e86-a2cede797d8c",
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fbrute-sled-pads-HQ1.jpg?alt=media&token=7af24b49-1231-4fd5-9c61-51bc9f7ca921"
        ]
    },{
        id: 'p8',
        name: '3 Man Brute Sled',
        sku: '9713',
        description: "Individual components allow stations to be added as the need arises. Basic sleds can start with man capability and expanded as you desire. A 5 man sled can be easily broken down to a 2 and a 3 man sled. Sled skids are formed, not cut and welded. A 30 degree angle assures you of a smooth transition over your grass without chewing up the turf. Safe for artificial turf. Each brute sled pad's core is built from high density, 100 lb., impact resistant foam. Durable, 18 oz. vinyl covers are then double and triple stitched to withstand harsh weather and years of hard use. Choose from 6 pad styles and 11 colors for the brute sled. COACHES PLATFORM NOT INCLUDED.",
        details: [
            'SKU: 9713M',
            "Doesn't chew up grass or artificial turf",
            'Weight: 582 lbs'
        ],
        options: [
            '9713AP: Attack pad',
            '9713T: T pad',
            '9713M: Man pad',
            '9713V: V pad',
            '9713SM: Small man pad'
        ],
        category: 'football',
        subCategory: 'sleds',
        urlCategory: 'football',
        urlSubCategory: 'sleds',
        image: "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fbrute-sled-3man-9713-HQ1.jpg?alt=media&token=cf2dc82e-1e35-4d69-8695-87c0f4d8b4b2",
        images: [
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fbrute-sled-3man-9713-HQ1.jpg?alt=media&token=cf2dc82e-1e35-4d69-8695-87c0f4d8b4b2",
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fbrute-sled-pads-HQ1.jpg?alt=media&token=7af24b49-1231-4fd5-9c61-51bc9f7ca921"
        ]
    },{
        id: 'p9',
        name: '4 Man Brute Sled',
        sku: '9714',
        description: "Individual components allow stations to be added as the need arises. Basic sleds can start with man capability and expanded as you desire. A 5 man sled can be easily broken down to a 2 and a 3 man sled. Sled skids are formed, not cut and welded. A 30 degree angle assures you of a smooth transition over your grass without chewing up the turf. Safe for artificial turf. Each brute sled pad's core is built from high density, 100 lb., impact resistant foam. Durable, 18 oz. vinyl covers are then double and triple stitched to withstand harsh weather and years of hard use. Choose from 6 pad styles and 11 colors for the brute sled. COACHES PLATFORM NOT INCLUDED.",
        details: [
            'SKU: 9714M',
            "Doesn't chew up grass or artificial turf",
            'Weight: 792 lbs'
        ],
        options: [
            '9714AP: Attack pad',
            '9714T: T pad',
            '9714M: Man pad',
            '9714V: V pad',
            '9714SM: Small man pad'
        ],
        category: 'football',
        subCategory: 'sleds',
        urlCategory: 'football',
        urlSubCategory: 'sleds',
        image: "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fbrute-sled-4man-9714-HQ1.jpg?alt=media&token=e6073232-0def-4b4e-9d74-62d3941d9fb0",
        images: [
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fbrute-sled-4man-9714-HQ1.jpg?alt=media&token=e6073232-0def-4b4e-9d74-62d3941d9fb0",
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fbrute-sled-pads-HQ1.jpg?alt=media&token=7af24b49-1231-4fd5-9c61-51bc9f7ca921"
        ]
    },{
        id: 'p10',
        name: '5 Man Brute Sled',
        sku: '9715',
        description: "Individual components allow stations to be added as the need arises. Basic sleds can start with man capability and expanded as you desire. A 5 man sled can be easily broken down to a 2 and a 3 man sled. Sled skids are formed, not cut and welded. A 30 degree angle assures you of a smooth transition over your grass without chewing up the turf. Safe for artificial turf. Each brute sled pad's core is built from high density, 100 lb., impact resistant foam. Durable, 18 oz. vinyl covers are then double and triple stitched to withstand harsh weather and years of hard use. Choose from 6 pad styles and 11 colors for the brute sled. COACHES PLATFORM NOT INCLUDED.",
        details: [
            'SKU: 9715M',
            "Doesn't chew up grass or artificial turf",
            'Weight: 1001 lbs'
        ],
        options: [
            '9715AP: Attack pad',
            '9715T: T pad',
            '9715M: Man pad',
            '9715V: V pad',
            '9715SM: Small man pad'
        ],
        category: 'football',
        subCategory: 'sleds',
        urlCategory: 'football',
        urlSubCategory: 'sleds',
        image: "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fbrute-sled-5man-9715-HQ1.jpg?alt=media&token=30a073d7-0588-4e52-a388-f25f12c2fd38",
        images: [
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fbrute-sled-5man-9715-HQ1.jpg?alt=media&token=30a073d7-0588-4e52-a388-f25f12c2fd38",
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fbrute-sled-5man-9715-HQ1.jpg?alt=media&token=30a073d7-0588-4e52-a388-f25f12c2fd38",
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fbrute-sled-5man-9715-HQ2.jpg?alt=media&token=36c16c80-5904-4b78-9a72-b68b3e997df4",
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fbrute-sled-pads-HQ1.jpg?alt=media&token=7af24b49-1231-4fd5-9c61-51bc9f7ca921"
        ]
    },{
        id: 'p11',
        name: '6 Man Brute Sled',
        sku: '9716',
        description: "Individual components allow stations to be added as the need arises. Basic sleds can start with man capability and expanded as you desire. A 5 man sled can be easily broken down to a 2 and a 3 man sled. Sled skids are formed, not cut and welded. A 30 degree angle assures you of a smooth transition over your grass without chewing up the turf. Safe for artificial turf. Each brute sled pad's core is built from high density, 100 lb., impact resistant foam. Durable, 18 oz. vinyl covers are then double and triple stitched to withstand harsh weather and years of hard use. Choose from 6 pad styles and 11 colors for the brute sled. COACHES PLATFORM NOT INCLUDED.",
        details: [
            'SKU: 9716M',
            "Doesn't chew up grass or artificial turf",
            'Weight: 1210 lbs'
        ],
        options: [
            '9716AP: Attack pad',
            '9716T: T pad',
            '9716M: Man pad',
            '9716V: V pad',
            '9716SM: Small man pad'
        ],
        category: 'football',
        subCategory: 'sleds',
        urlCategory: 'football',
        urlSubCategory: 'sleds',
        image: "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fbrute-sled-6man-9716-HQ1.jpg?alt=media&token=c42bfe58-c16d-4458-8eb6-33a7c58847a4",
        images: [
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fbrute-sled-6man-9716-HQ1.jpg?alt=media&token=c42bfe58-c16d-4458-8eb6-33a7c58847a4",
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fbrute-sled-pads-HQ1.jpg?alt=media&token=7af24b49-1231-4fd5-9c61-51bc9f7ca921"
        ]
    },{
        id: 'p12',
        name: '7 Man Brute Sled',
        sku: '9717',
        description: "Individual components allow stations to be added as the need arises. Basic sleds can start with man capability and expanded as you desire. A 5 man sled can be easily broken down to a 2 and a 3 man sled. Sled skids are formed, not cut and welded. A 30 degree angle assures you of a smooth transition over your grass without chewing up the turf. Safe for artificial turf. Each brute sled pad's core is built from high density, 100 lb., impact resistant foam. Durable, 18 oz. vinyl covers are then double and triple stitched to withstand harsh weather and years of hard use. Choose from 6 pad styles and 11 colors for the brute sled. COACHES PLATFORM NOT INCLUDED.",
        details: [
            'SKU: 9717M',
            "Doesn't chew up grass or artificial turf",
            'Weight: 1420 lbs'
        ],
        options: [
            '9717AP: Attack pad',
            '9717T: T pad',
            '9717M: Man pad',
            '9717V: V pad',
            '9717SM: Small man pad'
        ],
        category: 'football',
        subCategory: 'sleds',
        urlCategory: 'football',
        urlSubCategory: 'sleds',
        image: "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fbrute-sled-7man-9717-HQ2.jpg?alt=media&token=ea49767b-3e72-49ab-be69-f338c23d64cd",
        images: [
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fbrute-sled-7man-9717-HQ2.jpg?alt=media&token=ea49767b-3e72-49ab-be69-f338c23d64cd",
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fbrute-sled-7man-9717-HQ1.jpg?alt=media&token=9763fa8a-cf9a-469b-aada-3fafefbc859e",
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fbrute-sled-pads-HQ1.jpg?alt=media&token=7af24b49-1231-4fd5-9c61-51bc9f7ca921"
        ]
    },{
        id: 'p13',
        name: 'Shiver Sled',
        sku: '9708ss',
        description: 'Allows players to work on footwork while shuffling across pad. Players progress down the pad to repeat blows, gaining maximum repetitions. Teaches proper punch technique while using proper body position and footwork. Pad is 12" high x 8" long x 8" thick. Adjust from 32" to 44" tall.',
        details: [
            'SKU: 9708SS',
            `Pad is 12" high x 8' long x 8" thick`,
            `Adjusts from 32" to 44" tall`,
            `Doesn't chew up grass or artificial turf`,
            'Weight: 515 lbs'
        ],
        options: [
            '9708SSGM: Shiver sled mounted in ground'
        ],
        category: 'football',
        subCategory: 'sleds',
        urlCategory: 'football',
        urlSubCategory: 'sleds',
        image: "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fshiver-sled-9708ss-HQ1.jpg?alt=media&token=0941435f-e934-4ad1-abd5-463f2fde07b3",
        images: [
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fshiver-sled-9708ss-HQ1.jpg?alt=media&token=0941435f-e934-4ad1-abd5-463f2fde07b3",
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fshiver-sled-9708ss-HQ2.jpg?alt=media&token=5cf7e856-8304-48ef-896c-401c94d55c22",
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fshiver-sled-9708ss-HQ3.jpg?alt=media&token=1a7ac351-ce93-4e9d-953b-eab4369fcb1a"
        ]
    },{
        id: 'p14',
        name: 'Shiver Sled Ground',
        sku: '9708ssgm',
        description: 'Allows players to work on footwork while shuffling across pad. Players progress down the pad to repeat blows, gaining maximum repetitions. Teaches proper punch technique while using proper body position and footwork. Pad is 12" high x 8" long x 8" thick.',
        details: [
            'SKU: 9708SSGM',
            `Pad is 12" high x 8' long x 8" thick`,
            'Weight: 610 lbs'
        ],
        options: [
            '9708SS: Shiver sled mounted on runners'
        ],
        category: 'football',
        subCategory: 'sleds',
        urlCategory: 'football',
        urlSubCategory: 'sleds',
        image: "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fshiver-sled-ground-9708ssgm-HQ1.jpg?alt=media&token=bc4732a8-5e8d-4de7-b658-b16f8c643cd6",
        images: [
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fshiver-sled-ground-9708ssgm-HQ1.jpg?alt=media&token=bc4732a8-5e8d-4de7-b658-b16f8c643cd6"
        ]
    },{
        id: 'p15',
        name: '2 Man 9800 Sled',
        sku: '9802',
        description: `Wrap around padded wings on each pad protect your players. Choice of standard or "T" pad. Safely teaches a young player how to gain leverage on an opponent. Main Frame: Sturdy, tough steel construction. Guaranteed for 5 years. All metal surfaces are powder coated to prevent rust. Expandable: Individual components allow stations to be added as the need arises. Basic sleds can start with 2 man capability and expanded as you desire. A 5 man sled can be easily broken down to a 2 and a 3 man sled. Tite-Lock Chassis: New, improved interlocking modular design. Overlapped channel steel construction provides the rigidity needed in a multi-unit sled. Skids: Sled skids are formed, not cut and welded. A 30 degree angle assures you of a smooth transition over your grass without chewing up the turf. Safe for artificial turf. Pad construction and options: Each 9800 series sled pad's core is built from high density, 100 lb. impact resistant foam. Durable, 18 oz. vinyl covers are then double and triple stitched to withstand harsh weather and years of hard use. Standard and "T" pad styles are available for the 9800 series sleds.`,
        details: [
            'SKU: 9802TJR',
            `5 year warranty`,
            `Metal surfaces are powder coated to prevent rust`,
            `Expandable: Individual components allow stations to be added as the need arises`,
            `Doesn't chew up grass or artificial turf`,
            'Weight: 182 lbs'
        ],
        options: [
            '9800SJR: Standard pad',
            '9800TJR: "T" pad'
        ],
        category: 'football',
        subCategory: 'sleds youth football',
        urlCategory: 'football',
        urlSubCategory: 'youth football',
        image: "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2F2man-9800-sled-9802-HQ1.jpg?alt=media&token=def7e28e-efa5-49bd-9832-9aa50fe6b1f6",
        images: [
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2F2man-9800-sled-9802-HQ1.jpg?alt=media&token=def7e28e-efa5-49bd-9832-9aa50fe6b1f6",
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2F2man-9800-sled-9802-HQ2.jpg?alt=media&token=c00c0065-e1c6-458c-b3c3-7aedbfda6ed3",
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2F9800-sled-detail-HQ1.jpg?alt=media&token=f993021b-8f46-4ce3-af38-daafc836bc5c",
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2F9800-sled-pads-HQ1.jpg?alt=media&token=22845d08-9214-4953-a756-456305767757"
        ]
    },{
        id: 'p16',
        name: '3 Man 9800 Sled',
        sku: '9803',
        description: `Wrap around padded wings on each pad protect your players. Choice of standard or "T" pad. Safely teaches a young player how to gain leverage on an opponent. Main Frame: Sturdy, tough steel construction. Guaranteed for 5 years. All metal surfaces are powder coated to prevent rust. Expandable: Individual components allow stations to be added as the need arises. Basic sleds can start with 2 man capability and expanded as you desire. A 5 man sled can be easily broken down to a 2 and a 3 man sled. Tite-Lock Chassis: New, improved interlocking modular design. Overlapped channel steel construction provides the rigidity needed in a multi-unit sled. Skids: Sled skids are formed, not cut and welded. A 30 degree angle assures you of a smooth transition over your grass without chewing up the turf. Safe for artificial turf. Pad construction and options: Each 9800 series sled pad's core is built from high density, 100 lb. impact resistant foam. Durable, 18 oz. vinyl covers are then double and triple stitched to withstand harsh weather and years of hard use. Standard and "T" pad styles are available for the 9800 series sleds.`,
        details: [
            'SKU: 9803TJR',
            `5 year warranty`,
            `Metal surfaces are powder coated to prevent rust`,
            `Expandable: Individual components allow stations to be added as the need arises`,
            `Doesn't chew up grass or artificial turf`,
            'Weight: 294 lbs'
        ],
        options: [
            '9803SJR: Standard pad',
            '9803TJR: "T" pad'
        ],
        category: 'football',
        subCategory: 'sleds youth football',
        urlCategory: 'football',
        urlSubCategory: 'youth football',
        image: "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2F3man-9800-sled-9803-HQ1.jpg?alt=media&token=01134956-fbe6-4f8c-a2f0-ab722fdf7c6b",
        images: [
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2F3man-9800-sled-9803-HQ1.jpg?alt=media&token=01134956-fbe6-4f8c-a2f0-ab722fdf7c6b",
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2F9800-sled-detail-HQ1.jpg?alt=media&token=f993021b-8f46-4ce3-af38-daafc836bc5c",
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2F9800-sled-pads-HQ1.jpg?alt=media&token=22845d08-9214-4953-a756-456305767757"
        ]
    },{
        id: 'p17',
        name: '4 Man 9800 Sled',
        sku: '9804',
        description: `Wrap around padded wings on each pad protect your players. Choice of standard or "T" pad. Safely teaches a young player how to gain leverage on an opponent. Main Frame: Sturdy, tough steel construction. Guaranteed for 5 years. All metal surfaces are powder coated to prevent rust. Expandable: Individual components allow stations to be added as the need arises. Basic sleds can start with 2 man capability and expanded as you desire. A 5 man sled can be easily broken down to a 2 and a 3 man sled. Tite-Lock Chassis: New, improved interlocking modular design. Overlapped channel steel construction provides the rigidity needed in a multi-unit sled. Skids: Sled skids are formed, not cut and welded. A 30 degree angle assures you of a smooth transition over your grass without chewing up the turf. Safe for artificial turf. Pad construction and options: Each 9800 series sled pad's core is built from high density, 100 lb. impact resistant foam. Durable, 18 oz. vinyl covers are then double and triple stitched to withstand harsh weather and years of hard use. Standard and "T" pad styles are available for the 9800 series sleds.`,
        details: [
            'SKU: 9804TJR',
            `5 year warranty`,
            `Metal surfaces are powder coated to prevent rust`,
            `Expandable: Individual components allow stations to be added as the need arises`,
            `Doesn't chew up grass or artificial turf`,
            'Weight: 406 lbs'
        ],
        options: [
            '9804SJR: Standard pad',
            '9804TJR: "T" pad'
        ],
        category: 'football',
        subCategory: 'sleds youth football',
        urlCategory: 'football',
        urlSubCategory: 'youth football',
        image: "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2F4man-9800-sled-9804-HQ1.jpg?alt=media&token=5c97f9cd-cd07-45a9-9bd6-0ed9eef286a5",
        images: [
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2F4man-9800-sled-9804-HQ1.jpg?alt=media&token=5c97f9cd-cd07-45a9-9bd6-0ed9eef286a5",
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2F9800-sled-detail-HQ1.jpg?alt=media&token=f993021b-8f46-4ce3-af38-daafc836bc5c",
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2F9800-sled-pads-HQ1.jpg?alt=media&token=22845d08-9214-4953-a756-456305767757"
        ]
    },{
        id: 'p18',
        name: '5 Man 9800 Sled',
        sku: '9805',
        description: `Wrap around padded wings on each pad protect your players. Choice of standard or "T" pad. Safely teaches a young player how to gain leverage on an opponent. Main Frame: Sturdy, tough steel construction. Guaranteed for 5 years. All metal surfaces are powder coated to prevent rust. Expandable: Individual components allow stations to be added as the need arises. Basic sleds can start with 2 man capability and expanded as you desire. A 5 man sled can be easily broken down to a 2 and a 3 man sled. Tite-Lock Chassis: New, improved interlocking modular design. Overlapped channel steel construction provides the rigidity needed in a multi-unit sled. Skids: Sled skids are formed, not cut and welded. A 30 degree angle assures you of a smooth transition over your grass without chewing up the turf. Safe for artificial turf. Pad construction and options: Each 9800 series sled pad's core is built from high density, 100 lb. impact resistant foam. Durable, 18 oz. vinyl covers are then double and triple stitched to withstand harsh weather and years of hard use. Standard and "T" pad styles are available for the 9800 series sleds.`,
        details: [
            'SKU: 9805TJR',
            `5 year warranty`,
            `Metal surfaces are powder coated to prevent rust`,
            `Expandable: Individual components allow stations to be added as the need arises`,
            `Doesn't chew up grass or artificial turf`,
            'Weight: 517 lbs'
        ],
        options: [
            '9805SJR: Standard pad',
            '9805TJR: "T" pad'
        ],
        category: 'football',
        subCategory: 'sleds youth football',
        urlCategory: 'football',
        urlSubCategory: 'youth football',
        image: "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2F5man-9800-sled-9805-HQ1.jpg?alt=media&token=7c3cdaab-4137-434a-ae87-8c09567346f2",
        images: [
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2F5man-9800-sled-9805-HQ1.jpg?alt=media&token=7c3cdaab-4137-434a-ae87-8c09567346f2",
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2F5man-9800-sled-9805-HQ2.jpg?alt=media&token=30dbac6b-daea-4330-9a22-4bb11d9707aa",
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2F9800-sled-detail-HQ1.jpg?alt=media&token=f993021b-8f46-4ce3-af38-daafc836bc5c",
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2F9800-sled-pads-HQ1.jpg?alt=media&token=22845d08-9214-4953-a756-456305767757"
        ]
    },{
        id: 'p19',
        name: '6 Man 9800 Sled',
        sku: '9806',
        description: `Wrap around padded wings on each pad protect your players. Choice of standard or "T" pad. Safely teaches a young player how to gain leverage on an opponent. Main Frame: Sturdy, tough steel construction. Guaranteed for 5 years. All metal surfaces are powder coated to prevent rust. Expandable: Individual components allow stations to be added as the need arises. Basic sleds can start with 2 man capability and expanded as you desire. A 5 man sled can be easily broken down to a 2 and a 3 man sled. Tite-Lock Chassis: New, improved interlocking modular design. Overlapped channel steel construction provides the rigidity needed in a multi-unit sled. Skids: Sled skids are formed, not cut and welded. A 30 degree angle assures you of a smooth transition over your grass without chewing up the turf. Safe for artificial turf. Pad construction and options: Each 9800 series sled pad's core is built from high density, 100 lb. impact resistant foam. Durable, 18 oz. vinyl covers are then double and triple stitched to withstand harsh weather and years of hard use. Standard and "T" pad styles are available for the 9800 series sleds.`,
        details: [
            'SKU: 9806TJR',
            `5 year warranty`,
            `Metal surfaces are powder coated to prevent rust`,
            `Expandable: Individual components allow stations to be added as the need arises`,
            `Doesn't chew up grass or artificial turf`,
            'Weight: 629 lbs'
        ],
        options: [
            '9806SJR: Standard pad',
            '9806TJR: "T" pad'
        ],
        category: 'football',
        subCategory: 'sleds youth football',
        urlCategory: 'football',
        urlSubCategory: 'youth football',
        image: "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2F5man-9800-sled-9805-HQ1.jpg?alt=media&token=7c3cdaab-4137-434a-ae87-8c09567346f2",
        images: [
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2F5man-9800-sled-9805-HQ1.jpg?alt=media&token=7c3cdaab-4137-434a-ae87-8c09567346f2",
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2F9800-sled-detail-HQ1.jpg?alt=media&token=f993021b-8f46-4ce3-af38-daafc836bc5c",
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2F9800-sled-pads-HQ1.jpg?alt=media&token=22845d08-9214-4953-a756-456305767757"
        ]
    },{
        id: 'p20',
        name: '7 Man 9800 Sled',
        sku: '9807',
        description: `Wrap around padded wings on each pad protect your players. Choice of standard or "T" pad. Safely teaches a young player how to gain leverage on an opponent. Main Frame: Sturdy, tough steel construction. Guaranteed for 5 years. All metal surfaces are powder coated to prevent rust. Expandable: Individual components allow stations to be added as the need arises. Basic sleds can start with 2 man capability and expanded as you desire. A 5 man sled can be easily broken down to a 2 and a 3 man sled. Tite-Lock Chassis: New, improved interlocking modular design. Overlapped channel steel construction provides the rigidity needed in a multi-unit sled. Skids: Sled skids are formed, not cut and welded. A 30 degree angle assures you of a smooth transition over your grass without chewing up the turf. Safe for artificial turf. Pad construction and options: Each 9800 series sled pad's core is built from high density, 100 lb. impact resistant foam. Durable, 18 oz. vinyl covers are then double and triple stitched to withstand harsh weather and years of hard use. Standard and "T" pad styles are available for the 9800 series sleds.`,
        details: [
            'SKU: 9807TJR',
            `5 year warranty`,
            `Metal surfaces are powder coated to prevent rust`,
            `Expandable: Individual components allow stations to be added as the need arises`,
            `Doesn't chew up grass or artificial turf`,
            'Weight: 741 lbs'
        ],
        options: [
            '9807SJR: Standard pad',
            '9807TJR: "T" pad'
        ],
        category: 'football',
        subCategory: 'sleds youth football',
        urlCategory: 'football',
        urlSubCategory: 'youth football',
        image: "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2F7man-9800-sled-9807-HQ1.jpg?alt=media&token=9d9c37a5-2d32-4f5e-88f4-b94f2e9e5797",
        images: [
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2F7man-9800-sled-9807-HQ1.jpg?alt=media&token=9d9c37a5-2d32-4f5e-88f4-b94f2e9e5797",
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2F9800-sled-detail-HQ1.jpg?alt=media&token=f993021b-8f46-4ce3-af38-daafc836bc5c",
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2F9800-sled-pads-HQ1.jpg?alt=media&token=22845d08-9214-4953-a756-456305767757"
        ]
    },{
        id: 'p21',
        name: 'Pro Sackbak Sled',
        sku: '9301',
        description: `The Sackbak tackle sled is the closest simulation of a one on one game scenario, whether it is an open field tackle or a block. The Fisher SackBak allows players to apply proper tackling technique and follow through. Fisher's one man tackle sled helps to develop upper and lower body strength while enhancing a player's confidence.`,
        details: [
            'SKU: 9301R',
            `Sled pad core is built from high quality 100 lb impact resisitant foam`,
            `Durable 18 oz vinyl is double and triple stitched`,
            `Doesn't chew up grass or artificial turf`,
            'Weight: 295 lbs'
        ],
        options: [
            '9301R: Round pad',
            '9301C: Cone pad',
            '9301A: Attack pad'
        ],
        category: 'football',
        subCategory: 'sleds',
        urlCategory: 'football',
        urlSubCategory: 'sleds',
        image: "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fpro-sackback-sled-9301r-HQ1.jpg?alt=media&token=a9fbc2cd-8acd-4a07-82c2-ffc7bbcb7298",
        images: [
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fpro-sackback-sled-9301r-HQ1.jpg?alt=media&token=a9fbc2cd-8acd-4a07-82c2-ffc7bbcb7298"
        ]
    },{
        id: 'p22',
        name: 'Varsity Sackbak Sled',
        sku: '9201',
        description: `The Sackbak tackle sled is the closest simulation of a one on one game scenario, whether it is an open field tackle or a block. The Fisher SackBak allows players to apply proper tackling technique and follow through. Fisher's one man tackle sled helps to develop upper and lower body strength while enhancing a player's confidence.`,
        details: [
            'SKU: 9201C',
            `Sled pad core is built from high quality 100 lb impact resisitant foam`,
            `Durable 18 oz vinyl is double and triple stitched`,
            `Doesn't chew up grass or artificial turf`,
            'Weight: 225 lbs'
        ],
        options: [
            '9201R: Round pad',
            '9201C: Cone pad',
            '9201A: Attack pad'
        ],
        category: 'football',
        subCategory: 'sleds',
        urlCategory: 'football',
        urlSubCategory: 'sleds',
        image: "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fvarsity-sackback-sled-9201c-HQ1.jpg?alt=media&token=07edf03c-4f25-46ea-833e-884fffaec976",
        images: [
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fvarsity-sackback-sled-9201c-HQ1.jpg?alt=media&token=07edf03c-4f25-46ea-833e-884fffaec976"
        ]
    },{
        id: 'p23',
        name: 'JV Tackle Sled',
        sku: '9211',
        description: `Provides proper and safe training where it counts most from the start. This tool reinforces proper tackling techniques. To take the sled from its upright position to the ground, every player must hit low, use proper leg drive, shoulder position and tackling position. Base: 31" x 80" Weight: 175 lbs.`,
        details: [
            'SKU: 9211R',
            `Sled pad core is built from high quality 100 lb impact resisitant foam`,
            `Durable 18 oz vinyl is double and triple stitched`,
            `Doesn't chew up grass or artificial turf`,
            `Base: 31" x 80`,
            'Weight: 175 lbs'
        ],
        options: [
            '9211R: Round pad',
            '9211M: Man pad'
        ],
        category: 'football',
        subCategory: 'sleds youth football',
        urlCategory: 'football',
        urlSubCategory: 'youth football',
        image: "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fjv-sackback-sled-9211r-HQ1.jpg?alt=media&token=11e6c78d-9cb6-49c1-a523-f6610ff93b7e",
        images: [
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fjv-sackback-sled-9211r-HQ1.jpg?alt=media&token=11e6c78d-9cb6-49c1-a523-f6610ff93b7e",
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fyouth-tackle-sled-pads-HQ1.jpg?alt=media&token=e2712dc6-3413-45f3-a69a-d2ada862b4a7"
        ]
    },{
        id: 'p24',
        name: 'Youth Tackle Sled',
        sku: 'JRTS',
        description: `Provides proper and safe training where it counts most from the start. This tool reinforces proper tackling techniques. To take the sled from its upright position to the ground, every player must hit low, use proper leg drive, shoulder position and tackling position. Base: 23.5" x 58" Weight: 125 lbs.`,
        details: [
            'SKU: JRTS1',
            `Sled pad core is built from high quality 100 lb impact resisitant foam`,
            `Durable 18 oz vinyl is double and triple stitched`,
            `Doesn't chew up grass or artificial turf`,
            `Base: 23.5" x 58"`,
            'Weight: 125 lbs'
        ],
        options: [
            'JRTS1: Round pad',
            'JRTSM: Man pad'
        ],
        category: 'football',
        subCategory: 'sleds youth football',
        urlCategory: 'football',
        urlSubCategory: 'youth football',
        image: "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fyouth-tackle-sled-jrts1-HQ1.jpg?alt=media&token=c105ed1b-486f-44c3-9291-3cca735da54d",
        images: [
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fyouth-tackle-sled-jrts1-HQ1.jpg?alt=media&token=c105ed1b-486f-44c3-9291-3cca735da54d",
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fyouth-tackle-sled-pads-HQ1.jpg?alt=media&token=e2712dc6-3413-45f3-a69a-d2ada862b4a7"
        ]
    },{
        id: 'p25',
        name: '2 Man CL Sled',
        sku: 'cl2',
        description: `The CL series sleds from Fisher are ideal for middle school through high school programs. Our new TITE-LOCK modular chassis provides the rigidity needed in a multi-unit sled. Player safety is improved due to the wrap around design of our standard and "T" pads. Sled skids are formed, not cut and welded. A 30 degree angle assures you of a smooth transition over your grass without chewing up the turf. Safe for artificial turf. Main frame: tough, durable and guaranteed for 5 years. All metal surfaces are powder coated to prevent rust. The leaf spring design virtually eliminates all spring cracking and breaking common with other sleds.`,
        details: [
            'SKU: CL2T',
            '5 year warranty',
            'Expandable: Extra stations can be added as the need arises',
            'Durable 18 oz vinyl covers',
            'Made with high density, 100 lb, impact resisitant foam',
            'Coaches platform not included',
            'Weight: 247 lbs'
        ],
        options: [
            'CL2S: Standard pad',
            'CL2M: Man pad',
            'CL2T: T pad',
            `CLCP: Coach's Platform`
        ],
        category: 'football',
        subCategory: 'sleds',
        urlCategory: 'football',
        urlSubCategory: 'sleds',
        image: "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2F2-man-cl-sled-cl2-HQ1.jpg?alt=media&token=3e715013-cbd2-4f7d-820c-43b9dd36946a",
        images: [
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2F2-man-cl-sled-cl2-HQ1.jpg?alt=media&token=3e715013-cbd2-4f7d-820c-43b9dd36946a",
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fcl-sled-back-HQ1.jpg?alt=media&token=fcf86505-e258-43e3-b613-a5087482f0d8",
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fcl-sled-coaches-platform-HQ1.jpg?alt=media&token=75bfc60a-f4d5-447f-b7db-16e012bae023",
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fcl-sled-pads-HQ1.jpg?alt=media&token=45d885f5-6a6a-4d9b-a491-6d8c9f8f496d"
        ]
    },{
        id: 'p26',
        name: '3 Man CL Sled',
        sku: 'cl3',
        description: `The CL series sleds from Fisher are ideal for middle school through high school programs. Our new TITE-LOCK modular chassis provides the rigidity needed in a multi-unit sled. Player safety is improved due to the wrap around design of our standard and "T" pads. Sled skids are formed, not cut and welded. A 30 degree angle assures you of a smooth transition over your grass without chewing up the turf. Safe for artificial turf. Main frame: tough, durable and guaranteed for 5 years. All metal surfaces are powder coated to prevent rust. The leaf spring design virtually eliminates all spring cracking and breaking common with other sleds.`,
        details: [
            'SKU: CL3T',
            '5 year warranty',
            'Expandable: Extra stations can be added as the need arises',
            'Durable 18 oz vinyl covers',
            'Made with high density, 100 lb, impact resisitant foam',
            'Coaches platform not included',
            'Weight: 392 lbs'
        ],
        options: [
            'CL3S: Standard pad',
            'CL3M: Man pad',
            'CL3T: T pad',
            `CLCP: Coach's Platform`
        ],
        category: 'football',
        subCategory: 'sleds',
        urlCategory: 'football',
        urlSubCategory: 'sleds',
        image: "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2F3-man-cl-sled-cl3-HQ1.jpg?alt=media&token=5d43efd6-4724-43df-b069-92380f04c18b",
        images: [
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2F3-man-cl-sled-cl3-HQ1.jpg?alt=media&token=5d43efd6-4724-43df-b069-92380f04c18b",
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fcl-sled-back-HQ1.jpg?alt=media&token=fcf86505-e258-43e3-b613-a5087482f0d8",
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fcl-sled-coaches-platform-HQ1.jpg?alt=media&token=75bfc60a-f4d5-447f-b7db-16e012bae023",
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fcl-sled-pads-HQ1.jpg?alt=media&token=45d885f5-6a6a-4d9b-a491-6d8c9f8f496d"
        ]
    },{
        id: 'p27',
        name: '4 Man CL Sled',
        sku: 'cl4',
        description: `The CL series sleds from Fisher are ideal for middle school through high school programs. Our new TITE-LOCK modular chassis provides the rigidity needed in a multi-unit sled. Player safety is improved due to the wrap around design of our standard and "T" pads. Sled skids are formed, not cut and welded. A 30 degree angle assures you of a smooth transition over your grass without chewing up the turf. Safe for artificial turf. Main frame: tough, durable and guaranteed for 5 years. All metal surfaces are powder coated to prevent rust. The leaf spring design virtually eliminates all spring cracking and breaking common with other sleds.`,
        details: [
            'SKU: CL4T',
            '5 year warranty',
            'Expandable: Extra stations can be added as the need arises',
            'Durable 18 oz vinyl covers',
            'Made with high density, 100 lb, impact resisitant foam',
            'Coaches platform not included',
            'Weight: 537 lbs'
        ],
        options: [
            'CL4S: Standard pad',
            'CL4M: Man pad',
            'CL4T: T pad',
            `CLCP: Coach's Platform`
        ],
        category: 'football',
        subCategory: 'sleds',
        urlCategory: 'football',
        urlSubCategory: 'sleds',
        image: "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2F4-man-cl-sled-cl4-HQ1.jpg?alt=media&token=8c10ad10-b66e-4840-8009-26e48b7aed04",
        images: [
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2F4-man-cl-sled-cl4-HQ1.jpg?alt=media&token=8c10ad10-b66e-4840-8009-26e48b7aed04",
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fcl-sled-back-HQ1.jpg?alt=media&token=fcf86505-e258-43e3-b613-a5087482f0d8",
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fcl-sled-coaches-platform-HQ1.jpg?alt=media&token=75bfc60a-f4d5-447f-b7db-16e012bae023",
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fcl-sled-pads-HQ1.jpg?alt=media&token=45d885f5-6a6a-4d9b-a491-6d8c9f8f496d"
        ]
    },{
        id: 'p28',
        name: '5 Man CL Sled',
        sku: 'cl5',
        description: `The CL series sleds from Fisher are ideal for middle school through high school programs. Our new TITE-LOCK modular chassis provides the rigidity needed in a multi-unit sled. Player safety is improved due to the wrap around design of our standard and "T" pads. Sled skids are formed, not cut and welded. A 30 degree angle assures you of a smooth transition over your grass without chewing up the turf. Safe for artificial turf. Main frame: tough, durable and guaranteed for 5 years. All metal surfaces are powder coated to prevent rust. The leaf spring design virtually eliminates all spring cracking and breaking common with other sleds.`,
        details: [
            'SKU: CL5T',
            '5 year warranty',
            'Expandable: Extra stations can be added as the need arises',
            'Durable 18 oz vinyl covers',
            'Made with high density, 100 lb, impact resisitant foam',
            'Coaches platform not included',
            'Weight: 681 lbs'
        ],
        options: [
            'CL5S: Standard pad',
            'CL5M: Man pad',
            'CL5T: T pad',
            `CLCP: Coach's Platform`
        ],
        category: 'football',
        subCategory: 'sleds',
        urlCategory: 'football',
        urlSubCategory: 'sleds',
        image: "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2F5-man-cl-sled-cl5-HQ1.jpg?alt=media&token=4e0984e6-3e59-4005-b5cd-700ca58da8b4",
        images: [
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2F5-man-cl-sled-cl5-HQ1.jpg?alt=media&token=4e0984e6-3e59-4005-b5cd-700ca58da8b4",
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fcl-sled-back-HQ1.jpg?alt=media&token=fcf86505-e258-43e3-b613-a5087482f0d8",
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fcl-sled-coaches-platform-HQ1.jpg?alt=media&token=75bfc60a-f4d5-447f-b7db-16e012bae023",
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fcl-sled-pads-HQ1.jpg?alt=media&token=45d885f5-6a6a-4d9b-a491-6d8c9f8f496d"
        ]
    },{
        id: 'p29',
        name: '6 Man CL Sled',
        sku: 'cl6',
        description: `The CL series sleds from Fisher are ideal for middle school through high school programs. Our new TITE-LOCK modular chassis provides the rigidity needed in a multi-unit sled. Player safety is improved due to the wrap around design of our standard and "T" pads. Sled skids are formed, not cut and welded. A 30 degree angle assures you of a smooth transition over your grass without chewing up the turf. Safe for artificial turf. Main frame: tough, durable and guaranteed for 5 years. All metal surfaces are powder coated to prevent rust. The leaf spring design virtually eliminates all spring cracking and breaking common with other sleds.`,
        details: [
            'SKU: CL6T',
            '5 year warranty',
            'Expandable: Extra stations can be added as the need arises',
            'Durable 18 oz vinyl covers',
            'Made with high density, 100 lb, impact resisitant foam',
            'Coaches platform not included',
            'Weight: 826 lbs'
        ],
        options: [
            'CL6S: Standard pad',
            'CL6M: Man pad',
            'CL6T: T pad',
            `CLCP: Coach's Platform`
        ],
        category: 'football',
        subCategory: 'sleds',
        urlCategory: 'football',
        urlSubCategory: 'sleds',
        image: "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2F6-man-cl-sled-cl6-HQ1.jpg?alt=media&token=813f78f9-6a0b-4854-bf5c-6849294d643b",
        images: [
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2F6-man-cl-sled-cl6-HQ1.jpg?alt=media&token=813f78f9-6a0b-4854-bf5c-6849294d643b",
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fcl-sled-back-HQ1.jpg?alt=media&token=fcf86505-e258-43e3-b613-a5087482f0d8",
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fcl-sled-coaches-platform-HQ1.jpg?alt=media&token=75bfc60a-f4d5-447f-b7db-16e012bae023",
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fcl-sled-pads-HQ1.jpg?alt=media&token=45d885f5-6a6a-4d9b-a491-6d8c9f8f496d"
        ]
    },{
        id: 'p30',
        name: '7 Man CL Sled',
        sku: 'cl7',
        description: `The CL series sleds from Fisher are ideal for middle school through high school programs. Our new TITE-LOCK modular chassis provides the rigidity needed in a multi-unit sled. Player safety is improved due to the wrap around design of our standard and "T" pads. Sled skids are formed, not cut and welded. A 30 degree angle assures you of a smooth transition over your grass without chewing up the turf. Safe for artificial turf. Main frame: tough, durable and guaranteed for 5 years. All metal surfaces are powder coated to prevent rust. The leaf spring design virtually eliminates all spring cracking and breaking common with other sleds.`,
        details: [
            'SKU: CL7T',
            '5 year warranty',
            'Expandable: Extra stations can be added as the need arises',
            'Durable 18 oz vinyl covers',
            'Made with high density, 100 lb, impact resisitant foam',
            'Coaches platform not included',
            'Weight: 970 lbs'
        ],
        options: [
            'CL7S: Standard pad',
            'CL7M: Man pad',
            'CL7T: T pad',
            `CLCP: Coach's Platform`
        ],
        category: 'football',
        subCategory: 'sleds',
        urlCategory: 'football',
        urlSubCategory: 'sleds',
        image: "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2F6-man-cl-sled-cl6-HQ1.jpg?alt=media&token=813f78f9-6a0b-4854-bf5c-6849294d643b",
        images: [
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2F6-man-cl-sled-cl6-HQ1.jpg?alt=media&token=813f78f9-6a0b-4854-bf5c-6849294d643b",
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fcl-sled-back-HQ1.jpg?alt=media&token=fcf86505-e258-43e3-b613-a5087482f0d8",
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fcl-sled-coaches-platform-HQ1.jpg?alt=media&token=75bfc60a-f4d5-447f-b7db-16e012bae023",
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fcl-sled-pads-HQ1.jpg?alt=media&token=45d885f5-6a6a-4d9b-a491-6d8c9f8f496d"
        ]
    },{
        id: 'p31',
        name: '2 Man Brute 2 Sled',
        sku: '9722',
        description: `Fisher Brute 2 sleds are scaled down versions of our popular Brute sleds and are ideal for 6th through 9th grade players. Our TITE-LOCK modular chassis provides the rigidity needed in a multi-unit sled. Construction: Main Frame: 6" x 1/2" face plates mounted on sturdy 1/4" steel plates. Square tubing runners and skids have a caps and 100% welded flanges. Live action springs: Flat leaf springs deflect to absorb the shock and bounce back to provide realism in drills. Tite-Lock Chassis: New, improved interlocking modular design. Overlapped channel steel construction provides the rigidity needed in a multi-unit sled. Expandable: Individual components allow stations to be added as the need arises. Basic sleds can start with 2 man capability and expanded as you desire. A 5 man sled can be easily broken down to a 2 and a 3 man sled.`,
        details: [
            'SKU: 9722JRC',
            'Ideal for 6th through 9th grade players',
            '5 year warranty',
            'Expandable: Extra stations can be added as the need arises',
            'Durable 18 oz vinyl covers',
            'Made with high density, 100 lb, impact resisitant foam',
            'Coaches platform not included',
            'Weight: 235 lbs'
        ],
        options: [
            '9722JRC: Cone pad',
            '9722JRM: Man pad',
            '9722JRR: Round pad'
        ],
        category: 'football',
        subCategory: 'sleds youth football',
        urlCategory: 'football',
        urlSubCategory: 'youth football',
        image: "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fbrute-sled-2man-9712-HQ.jpg?alt=media&token=013429a3-7a36-416c-a117-b2ceef40a66d",
        images: [
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fbrute-sled-2man-9712-HQ.jpg?alt=media&token=013429a3-7a36-416c-a117-b2ceef40a66d",
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fbrute-sled-2man-9712-HQ2.jpg?alt=media&token=9d3272e0-8e7e-489b-9e86-a2cede797d8c",
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fbrute2-sled-pads-HQ1.jpg?alt=media&token=adf514f4-468c-4765-bbea-77ab6f780e1d"
        ]
    },{
        id: 'p32',
        name: '3 Man Brute 2 Sled',
        sku: '9723',
        description: `Fisher Brute 2 sleds are scaled down versions of our popular Brute sleds and are ideal for 6th through 9th grade players. Our TITE-LOCK modular chassis provides the rigidity needed in a multi-unit sled. Construction: Main Frame: 6" x 1/2" face plates mounted on sturdy 1/4" steel plates. Square tubing runners and skids have a caps and 100% welded flanges. Live action springs: Flat leaf springs deflect to absorb the shock and bounce back to provide realism in drills. Tite-Lock Chassis: New, improved interlocking modular design. Overlapped channel steel construction provides the rigidity needed in a multi-unit sled. Expandable: Individual components allow stations to be added as the need arises. Basic sleds can start with 2 man capability and expanded as you desire. A 5 man sled can be easily broken down to a 2 and a 3 man sled.`,
        details: [
            'SKU: 9723JRC',
            'Ideal for 6th through 9th grade players',
            '5 year warranty',
            'Expandable: Extra stations can be added as the need arises',
            'Durable 18 oz vinyl covers',
            'Made with high density, 100 lb, impact resisitant foam',
            'Coaches platform not included',
            'Weight: 366 lbs'
        ],
        options: [
            '9723JRC: Cone pad',
            '9723JRM: Man pad',
            '9723JRR: Round pad'
        ],
        category: 'football',
        subCategory: 'sleds youth football',
        urlCategory: 'football',
        urlSubCategory: 'youth football',
        image: "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fbrute-sled-3man-9713-HQ1.jpg?alt=media&token=cf2dc82e-1e35-4d69-8695-87c0f4d8b4b2",
        images: [
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fbrute-sled-3man-9713-HQ1.jpg?alt=media&token=cf2dc82e-1e35-4d69-8695-87c0f4d8b4b2",
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fbrute2-sled-pads-HQ1.jpg?alt=media&token=adf514f4-468c-4765-bbea-77ab6f780e1d"
        ]
    },{
        id: 'p33',
        name: '4 Man Brute 2 Sled',
        sku: '9724',
        description: `Fisher Brute 2 sleds are scaled down versions of our popular Brute sleds and are ideal for 6th through 9th grade players. Our TITE-LOCK modular chassis provides the rigidity needed in a multi-unit sled. Construction: Main Frame: 6" x 1/2" face plates mounted on sturdy 1/4" steel plates. Square tubing runners and skids have a caps and 100% welded flanges. Live action springs: Flat leaf springs deflect to absorb the shock and bounce back to provide realism in drills. Tite-Lock Chassis: New, improved interlocking modular design. Overlapped channel steel construction provides the rigidity needed in a multi-unit sled. Expandable: Individual components allow stations to be added as the need arises. Basic sleds can start with 2 man capability and expanded as you desire. A 5 man sled can be easily broken down to a 2 and a 3 man sled.`,
        details: [
            'SKU: 9724JRC',
            'Ideal for 6th through 9th grade players',
            '5 year warranty',
            'Expandable: Extra stations can be added as the need arises',
            'Durable 18 oz vinyl covers',
            'Made with high density, 100 lb, impact resisitant foam',
            'Coaches platform not included',
            'Weight: 497 lbs'
        ],
        options: [
            '9724JRC: Cone pad',
            '9724JRM: Man pad',
            '9724JRR: Round pad'
        ],
        category: 'football',
        subCategory: 'sleds youth football',
        urlCategory: 'football',
        urlSubCategory: 'youth football',
        image: "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fbrute-sled-4man-9714-HQ1.jpg?alt=media&token=e6073232-0def-4b4e-9d74-62d3941d9fb0",
        images: [
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fbrute-sled-4man-9714-HQ1.jpg?alt=media&token=e6073232-0def-4b4e-9d74-62d3941d9fb0",
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fbrute2-sled-pads-HQ1.jpg?alt=media&token=adf514f4-468c-4765-bbea-77ab6f780e1d"
        ]
    },{
        id: 'p34',
        name: '5 Man Brute 2 Sled',
        sku: '9725',
        description: `Fisher Brute 2 sleds are scaled down versions of our popular Brute sleds and are ideal for 6th through 9th grade players. Our TITE-LOCK modular chassis provides the rigidity needed in a multi-unit sled. Construction: Main Frame: 6" x 1/2" face plates mounted on sturdy 1/4" steel plates. Square tubing runners and skids have a caps and 100% welded flanges. Live action springs: Flat leaf springs deflect to absorb the shock and bounce back to provide realism in drills. Tite-Lock Chassis: New, improved interlocking modular design. Overlapped channel steel construction provides the rigidity needed in a multi-unit sled. Expandable: Individual components allow stations to be added as the need arises. Basic sleds can start with 2 man capability and expanded as you desire. A 5 man sled can be easily broken down to a 2 and a 3 man sled.`,
        details: [
            'SKU: 9725JRC',
            'Ideal for 6th through 9th grade players',
            '5 year warranty',
            'Expandable: Extra stations can be added as the need arises',
            'Durable 18 oz vinyl covers',
            'Made with high density, 100 lb, impact resisitant foam',
            'Coaches platform not included',
            'Weight: 628 lbs'
        ],
        options: [
            '9725JRC: Cone pad',
            '9725JRM: Man pad',
            '9725JRR: Round pad'
        ],
        category: 'football',
        subCategory: 'sleds youth football',
        urlCategory: 'football',
        urlSubCategory: 'youth football',
        image: "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fbrute-sled-5man-9715-HQ1.jpg?alt=media&token=30a073d7-0588-4e52-a388-f25f12c2fd38",
        images: [
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fbrute-sled-5man-9715-HQ1.jpg?alt=media&token=30a073d7-0588-4e52-a388-f25f12c2fd38",
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fbrute2-sled-pads-HQ1.jpg?alt=media&token=adf514f4-468c-4765-bbea-77ab6f780e1d"
        ]
    },{
        id: 'p35',
        name: '6 Man Brute 2 Sled',
        sku: '9726',
        description: `Fisher Brute 2 sleds are scaled down versions of our popular Brute sleds and are ideal for 6th through 9th grade players. Our TITE-LOCK modular chassis provides the rigidity needed in a multi-unit sled. Construction: Main Frame: 6" x 1/2" face plates mounted on sturdy 1/4" steel plates. Square tubing runners and skids have a caps and 100% welded flanges. Live action springs: Flat leaf springs deflect to absorb the shock and bounce back to provide realism in drills. Tite-Lock Chassis: New, improved interlocking modular design. Overlapped channel steel construction provides the rigidity needed in a multi-unit sled. Expandable: Individual components allow stations to be added as the need arises. Basic sleds can start with 2 man capability and expanded as you desire. A 5 man sled can be easily broken down to a 2 and a 3 man sled.`,
        details: [
            'SKU: 9726JRC',
            'Ideal for 6th through 9th grade players',
            '5 year warranty',
            'Expandable: Extra stations can be added as the need arises',
            'Durable 18 oz vinyl covers',
            'Made with high density, 100 lb, impact resisitant foam',
            'Coaches platform not included',
            'Weight: 759 lbs'
        ],
        options: [
            '9726JRC: Cone pad',
            '9726JRM: Man pad',
            '9726JRR: Round pad'
        ],
        category: 'football',
        subCategory: 'sleds youth football',
        urlCategory: 'football',
        urlSubCategory: 'youth football',
        image: "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fbrute-sled-6man-9716-HQ1.jpg?alt=media&token=c42bfe58-c16d-4458-8eb6-33a7c58847a4",
        images: [
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fbrute-sled-6man-9716-HQ1.jpg?alt=media&token=c42bfe58-c16d-4458-8eb6-33a7c58847a4",
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fbrute2-sled-pads-HQ1.jpg?alt=media&token=adf514f4-468c-4765-bbea-77ab6f780e1d"
        ]
    },{
        id: 'p36',
        name: '7 Man Brute 2 Sled',
        sku: '9727',
        description: `Fisher Brute 2 sleds are scaled down versions of our popular Brute sleds and are ideal for 6th through 9th grade players. Our TITE-LOCK modular chassis provides the rigidity needed in a multi-unit sled. Construction: Main Frame: 6" x 1/2" face plates mounted on sturdy 1/4" steel plates. Square tubing runners and skids have a caps and 100% welded flanges. Live action springs: Flat leaf springs deflect to absorb the shock and bounce back to provide realism in drills. Tite-Lock Chassis: New, improved interlocking modular design. Overlapped channel steel construction provides the rigidity needed in a multi-unit sled. Expandable: Individual components allow stations to be added as the need arises. Basic sleds can start with 2 man capability and expanded as you desire. A 5 man sled can be easily broken down to a 2 and a 3 man sled.`,
        details: [
            'SKU: 9727JRC',
            'Ideal for 6th through 9th grade players',
            '5 year warranty',
            'Expandable: Extra stations can be added as the need arises',
            'Durable 18 oz vinyl covers',
            'Made with high density, 100 lb, impact resisitant foam',
            'Coaches platform not included',
            'Weight: 891 lbs'
        ],
        options: [
            '9727JRC: Cone pad',
            '9727JRM: Man pad',
            '9727JRR: Round pad'
        ],
        category: 'football',
        subCategory: 'sleds youth football',
        urlCategory: 'football',
        urlSubCategory: 'youth football',
        image: "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fbrute-sled-7man-9717-HQ2.jpg?alt=media&token=ea49767b-3e72-49ab-be69-f338c23d64cd",
        images: [
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fbrute-sled-7man-9717-HQ2.jpg?alt=media&token=ea49767b-3e72-49ab-be69-f338c23d64cd",
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fbrute-sled-7man-9717-HQ1.jpg?alt=media&token=9763fa8a-cf9a-469b-aada-3fafefbc859e",
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fbrute2-sled-pads-HQ1.jpg?alt=media&token=adf514f4-468c-4765-bbea-77ab6f780e1d"
        ]
    },{
        id: 'p37',
        name: 'Coaches Platform',
        sku: '9000cp',
        description: `The optional platform has a 36" tall, 2" O.D. hand rail and a sturdy, 30" steel diamond plate base for an excellent non-slip surface. The platform allows an up front view of drills and gives the feel of impact.`,
        details: [
            'SKU: 9000CP',
            '36" tall, 2" O.D. hand rail',
            '30" x 30" steel diamond plate base',
            'Non-slip surface'
        ],
        options: [
            '9000CP: Coaches Platform',
            'CLCP: Coaches Platform CL'
        ],
        category: 'football',
        subCategory: 'sleds',
        urlCategory: 'football',
        urlSubCategory: 'sleds',
        image: "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fcoaches-platform-9000cp-HQ1.jpg?alt=media&token=e31a3bff-41ec-449b-b730-88e25a526c63",
        images: [
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fcoaches-platform-9000cp-HQ1.jpg?alt=media&token=e31a3bff-41ec-449b-b730-88e25a526c63"
        ]
    },{
        id: 'p38',
        name: 'Coaches Platform CL',
        sku: 'clcp',
        description: `The optional platform has a 36" tall, 2" O.D. hand rail and a sturdy, 30" steel diamond plate base for an excellent non-slip surface. The platform allows an up front view of drills and gives the feel of impact.`,
        details: [
            'SKU: CLCP',
            '36" tall, 2" O.D. hand rail',
            '30" x 30" steel diamond plate base',
            'Non-slip surface'
        ],
        options: [
            'CLCP: Coaches Platform CL',
            '9000CP: Coaches Platform'
        ],
        category: 'football',
        subCategory: 'sleds',
        urlCategory: 'football',
        urlSubCategory: 'sleds',
        image: "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fcoaches-platform-cl-clcp-HQ1.jpg?alt=media&token=84ec65a1-f9eb-4323-8b7e-47e0b8b58d8d",
        images: [
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fcoaches-platform-cl-clcp-HQ1.jpg?alt=media&token=84ec65a1-f9eb-4323-8b7e-47e0b8b58d8d",
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fcoaches-platform-cl-clcp-HQ2.jpg?alt=media&token=107bf1a0-8a87-4552-bdee-8f00472e52a3"
        ]
    },{
        id: 'p39',
        name: '2 Man Big Boomer Sled',
        sku: '9002',
        description: `Realistic fulcrum pivoting action conditions your players to achieve leveraged power over an opponent without losing their balance. The only sled that is completely adjustable. Adjust spring tension, pad height and angle. Blocking Units: Each individual blocking unit is made up of "pigs" and pads. The "pig" is constructed with a high strength 1/4" steel place, double welded for maximum strength and durability. The "pig" attaches to the steel chassis and is fully adjustable.Our exclusive spring tension adjustment is an integral part of each "pig". The pad fits onto the "pig" and is fully adjustable. Pad construction and options: Each Boomer sled pad's core is built from high density, 100 lb., impact resistant foam. Durable, 18oz. vinyl covers are then double and triple stitched to withstand harsh weather and years of hard use. 5 Year Warranty: Main Frame: Tough, durable and guaranteed for 5 years. All metal surfaces are powder coated to prevent rust.`,
        details: [
            'SKU: 9002M',
            'Realistic fulcrum pivoting action',
            'Adjust spring tension, pad height, and angle',
            'Pads are made with high density, 100 lb, impact resistant foam and 18 oz vinyl covers',
            'Expandable: Individual components allow stations to be added as the need arises',
            'Weight: 354 lbs'
        ],
        options: [
            '9002M: Man Pad',
            '9002T: T Pad',
            '9002LB: Lowboy Pad',
            '9002AP: Attack Pad',
            '9002V: V Pad'
        ],
        category: 'football',
        subCategory: 'sleds',
        urlCategory: 'football',
        urlSubCategory: 'sleds',
        image: "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fbig-boomer-sled-2-man-9002-HQ1.jpg?alt=media&token=58f1f8bb-f9fb-405b-954f-621091360352",
        images: [
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fbig-boomer-sled-2-man-9002-HQ1.jpg?alt=media&token=58f1f8bb-f9fb-405b-954f-621091360352",
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fbig-boomer-sled-detail-HQ2.jpg?alt=media&token=26f075b7-a06b-4709-bb9b-77717ab674b8",
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fbig-boomer-sled-detail-HQ1.jpg?alt=media&token=db07046f-7c6c-457f-96e8-8a642bb1b027",
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fbig-boomer-sled-pads-HQ1.jpg?alt=media&token=28994df4-6891-4394-b69d-186b0fb44361",
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fbig-boomer-sled-detail-HQ3.jpg?alt=media&token=9eefab82-f7b0-40b7-94c3-34b4b2f9030a"
        ]
    },{
        id: 'p40',
        name: '3 Man Big Boomer Sled',
        sku: '9003',
        description: `Realistic fulcrum pivoting action conditions your players to achieve leveraged power over an opponent without losing their balance. The only sled that is completely adjustable. Adjust spring tension, pad height and angle. Blocking Units: Each individual blocking unit is made up of "pigs" and pads. The "pig" is constructed with a high strength 1/4" steel place, double welded for maximum strength and durability. The "pig" attaches to the steel chassis and is fully adjustable.Our exclusive spring tension adjustment is an integral part of each "pig". The pad fits onto the "pig" and is fully adjustable. Pad construction and options: Each Boomer sled pad's core is built from high density, 100 lb., impact resistant foam. Durable, 18oz. vinyl covers are then double and triple stitched to withstand harsh weather and years of hard use. 5 Year Warranty: Main Frame: Tough, durable and guaranteed for 5 years. All metal surfaces are powder coated to prevent rust.`,
        details: [
            'SKU: 9003M',
            'Realistic fulcrum pivoting action',
            'Adjust spring tension, pad height, and angle',
            'Pads are made with high density, 100 lb, impact resistant foam and 18 oz vinyl covers',
            'Expandable: Individual components allow stations to be added as the need arises',
            'Weight: 554 lbs'
        ],
        options: [
            '9003M: Man Pad',
            '9003T: T Pad',
            '9003LB: Lowboy Pad',
            '9003AP: Attack Pad',
            '9003V: V Pad'
        ],
        category: 'football',
        subCategory: 'sleds',
        urlCategory: 'football',
        urlSubCategory: 'sleds',
        image: "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fbig-boomer-sled-3-man-9003-HQ1.jpg?alt=media&token=13ad43ac-210e-4437-a109-49fdd6a1a9b0",
        images: [
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fbig-boomer-sled-3-man-9003-HQ1.jpg?alt=media&token=13ad43ac-210e-4437-a109-49fdd6a1a9b0",
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fbig-boomer-sled-detail-HQ2.jpg?alt=media&token=26f075b7-a06b-4709-bb9b-77717ab674b8",
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fbig-boomer-sled-detail-HQ1.jpg?alt=media&token=db07046f-7c6c-457f-96e8-8a642bb1b027",
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fbig-boomer-sled-pads-HQ1.jpg?alt=media&token=28994df4-6891-4394-b69d-186b0fb44361",
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fbig-boomer-sled-detail-HQ3.jpg?alt=media&token=9eefab82-f7b0-40b7-94c3-34b4b2f9030a"
        ]
    },{
        id: 'p41',
        name: '4 Man Big Boomer Sled',
        sku: '9004',
        description: `Realistic fulcrum pivoting action conditions your players to achieve leveraged power over an opponent without losing their balance. The only sled that is completely adjustable. Adjust spring tension, pad height and angle. Blocking Units: Each individual blocking unit is made up of "pigs" and pads. The "pig" is constructed with a high strength 1/4" steel place, double welded for maximum strength and durability. The "pig" attaches to the steel chassis and is fully adjustable.Our exclusive spring tension adjustment is an integral part of each "pig". The pad fits onto the "pig" and is fully adjustable. Pad construction and options: Each Boomer sled pad's core is built from high density, 100 lb., impact resistant foam. Durable, 18oz. vinyl covers are then double and triple stitched to withstand harsh weather and years of hard use. 5 Year Warranty: Main Frame: Tough, durable and guaranteed for 5 years. All metal surfaces are powder coated to prevent rust.`,
        details: [
            'SKU: 9004M',
            'Realistic fulcrum pivoting action',
            'Adjust spring tension, pad height, and angle',
            'Pads are made with high density, 100 lb, impact resistant foam and 18 oz vinyl covers',
            'Expandable: Individual components allow stations to be added as the need arises',
            'Weight: 754 lbs'
        ],
        options: [
            '9004M: Man Pad',
            '9004T: T Pad',
            '9004LB: Lowboy Pad',
            '9004AP: Attack Pad',
            '9004V: V Pad'
        ],
        category: 'football',
        subCategory: 'sleds',
        urlCategory: 'football',
        urlSubCategory: 'sleds',
        image: "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fbig-boomer-sled-4-man-9004-HQ1.jpg?alt=media&token=3311e6f0-14cc-4731-9034-cdd44a13576d",
        images: [
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fbig-boomer-sled-4-man-9004-HQ1.jpg?alt=media&token=3311e6f0-14cc-4731-9034-cdd44a13576d",
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fbig-boomer-sled-detail-HQ2.jpg?alt=media&token=26f075b7-a06b-4709-bb9b-77717ab674b8",
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fbig-boomer-sled-detail-HQ1.jpg?alt=media&token=db07046f-7c6c-457f-96e8-8a642bb1b027",
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fbig-boomer-sled-pads-HQ1.jpg?alt=media&token=28994df4-6891-4394-b69d-186b0fb44361",
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fbig-boomer-sled-detail-HQ3.jpg?alt=media&token=9eefab82-f7b0-40b7-94c3-34b4b2f9030a"
        ]
    },{
        id: 'p42',
        name: '5 Man Big Boomer Sled',
        sku: '9005',
        description: `Realistic fulcrum pivoting action conditions your players to achieve leveraged power over an opponent without losing their balance. The only sled that is completely adjustable. Adjust spring tension, pad height and angle. Blocking Units: Each individual blocking unit is made up of "pigs" and pads. The "pig" is constructed with a high strength 1/4" steel place, double welded for maximum strength and durability. The "pig" attaches to the steel chassis and is fully adjustable.Our exclusive spring tension adjustment is an integral part of each "pig". The pad fits onto the "pig" and is fully adjustable. Pad construction and options: Each Boomer sled pad's core is built from high density, 100 lb., impact resistant foam. Durable, 18oz. vinyl covers are then double and triple stitched to withstand harsh weather and years of hard use. 5 Year Warranty: Main Frame: Tough, durable and guaranteed for 5 years. All metal surfaces are powder coated to prevent rust.`,
        details: [
            'SKU: 9005M',
            'Realistic fulcrum pivoting action',
            'Adjust spring tension, pad height, and angle',
            'Pads are made with high density, 100 lb, impact resistant foam and 18 oz vinyl covers',
            'Expandable: Individual components allow stations to be added as the need arises',
            'Weight: 954 lbs'
        ],
        options: [
            '9005M: Man Pad',
            '9005T: T Pad',
            '9005LB: Lowboy Pad',
            '9005AP: Attack Pad',
            '9005V: V Pad'
        ],
        category: 'football',
        subCategory: 'sleds',
        urlCategory: 'football',
        urlSubCategory: 'sleds',
        image: "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fbig-boomer-sled-5-man-9005-HQ1.jpg?alt=media&token=b17aa622-aa8c-4295-be10-a9c700caf28e",
        images: [
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fbig-boomer-sled-5-man-9005-HQ1.jpg?alt=media&token=b17aa622-aa8c-4295-be10-a9c700caf28e",
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fbig-boomer-sled-detail-HQ2.jpg?alt=media&token=26f075b7-a06b-4709-bb9b-77717ab674b8",
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fbig-boomer-sled-detail-HQ1.jpg?alt=media&token=db07046f-7c6c-457f-96e8-8a642bb1b027",
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fbig-boomer-sled-pads-HQ1.jpg?alt=media&token=28994df4-6891-4394-b69d-186b0fb44361",
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fbig-boomer-sled-detail-HQ3.jpg?alt=media&token=9eefab82-f7b0-40b7-94c3-34b4b2f9030a"
        ]
    },{
        id: 'p43',
        name: '6 Man Big Boomer Sled',
        sku: '9006',
        description: `Realistic fulcrum pivoting action conditions your players to achieve leveraged power over an opponent without losing their balance. The only sled that is completely adjustable. Adjust spring tension, pad height and angle. Blocking Units: Each individual blocking unit is made up of "pigs" and pads. The "pig" is constructed with a high strength 1/4" steel place, double welded for maximum strength and durability. The "pig" attaches to the steel chassis and is fully adjustable.Our exclusive spring tension adjustment is an integral part of each "pig". The pad fits onto the "pig" and is fully adjustable. Pad construction and options: Each Boomer sled pad's core is built from high density, 100 lb., impact resistant foam. Durable, 18oz. vinyl covers are then double and triple stitched to withstand harsh weather and years of hard use. 5 Year Warranty: Main Frame: Tough, durable and guaranteed for 5 years. All metal surfaces are powder coated to prevent rust.`,
        details: [
            'SKU: 9006M',
            'Realistic fulcrum pivoting action',
            'Adjust spring tension, pad height, and angle',
            'Pads are made with high density, 100 lb, impact resistant foam and 18 oz vinyl covers',
            'Expandable: Individual components allow stations to be added as the need arises',
            'Weight: 1154 lbs'
        ],
        options: [
            '9006M: Man Pad',
            '9006T: T Pad',
            '9006LB: Lowboy Pad',
            '9006AP: Attack Pad',
            '9006V: V Pad'
        ],
        category: 'football',
        subCategory: 'sleds',
        urlCategory: 'football',
        urlSubCategory: 'sleds',
        image: "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fbig-boomer-sled-6-man-9006-HQ1.jpg?alt=media&token=11c543fe-fb0d-44d4-946b-7faeb768528c",
        images: [
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fbig-boomer-sled-6-man-9006-HQ1.jpg?alt=media&token=11c543fe-fb0d-44d4-946b-7faeb768528c",
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fbig-boomer-sled-detail-HQ2.jpg?alt=media&token=26f075b7-a06b-4709-bb9b-77717ab674b8",
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fbig-boomer-sled-detail-HQ1.jpg?alt=media&token=db07046f-7c6c-457f-96e8-8a642bb1b027",
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fbig-boomer-sled-pads-HQ1.jpg?alt=media&token=28994df4-6891-4394-b69d-186b0fb44361",
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fbig-boomer-sled-detail-HQ3.jpg?alt=media&token=9eefab82-f7b0-40b7-94c3-34b4b2f9030a"
        ]
    },{
        id: 'p44',
        name: '7 Man Big Boomer Sled',
        sku: '9007',
        description: `Realistic fulcrum pivoting action conditions your players to achieve leveraged power over an opponent without losing their balance. The only sled that is completely adjustable. Adjust spring tension, pad height and angle. Blocking Units: Each individual blocking unit is made up of "pigs" and pads. The "pig" is constructed with a high strength 1/4" steel place, double welded for maximum strength and durability. The "pig" attaches to the steel chassis and is fully adjustable.Our exclusive spring tension adjustment is an integral part of each "pig". The pad fits onto the "pig" and is fully adjustable. Pad construction and options: Each Boomer sled pad's core is built from high density, 100 lb., impact resistant foam. Durable, 18oz. vinyl covers are then double and triple stitched to withstand harsh weather and years of hard use. 5 Year Warranty: Main Frame: Tough, durable and guaranteed for 5 years. All metal surfaces are powder coated to prevent rust.`,
        details: [
            'SKU: 9007M',
            'Realistic fulcrum pivoting action',
            'Adjust spring tension, pad height, and angle',
            'Pads are made with high density, 100 lb, impact resistant foam and 18 oz vinyl covers',
            'Expandable: Individual components allow stations to be added as the need arises',
            'Weight: 1354 lbs'
        ],
        options: [
            '9007M: Man Pad',
            '9007T: T Pad',
            '9007LB: Lowboy Pad',
            '9007AP: Attack Pad',
            '9007V: V Pad'
        ],
        category: 'football',
        subCategory: 'sleds',
        urlCategory: 'football',
        urlSubCategory: 'sleds',
        image: "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fbig-boomer-sled-7-man-9007-HQ1.jpg?alt=media&token=574cb68f-d4f8-4e22-9a56-38eceef6cfb4",
        images: [
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fbig-boomer-sled-7-man-9007-HQ1.jpg?alt=media&token=574cb68f-d4f8-4e22-9a56-38eceef6cfb4",
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fbig-boomer-sled-detail-HQ2.jpg?alt=media&token=26f075b7-a06b-4709-bb9b-77717ab674b8",
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fbig-boomer-sled-detail-HQ1.jpg?alt=media&token=db07046f-7c6c-457f-96e8-8a642bb1b027",
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fbig-boomer-sled-pads-HQ1.jpg?alt=media&token=28994df4-6891-4394-b69d-186b0fb44361",
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fbig-boomer-sled-detail-HQ3.jpg?alt=media&token=9eefab82-f7b0-40b7-94c3-34b4b2f9030a"
        ]
    },{
        id: 'p45',
        name: '2 Man Bull Sled',
        sku: '9902',
        description: `Main Frame:Tough, durable and guaranteed for five years. Full 5 year warranty on metal parts. All metal surfaces are powder coated to prevent rust. Skids: Sled skids are formed, not cut and welded. 30 degree angles assure a smooth transition over our grass or artificial turf.`,
        details: [
            'SKU: 9902M',
            '5 Year guarantee',
            `Won't chew up grass or artificial turf`,
            'Powder coated to prevent rust',
            'Weight: 455 lbs'
        ],
        options: [
            '9902M: Man Pad',
            '9902BT: T Pad',
            '9902ZP: Zone Pad',
            '9902PP: Pummel Pad'
        ],
        category: 'football',
        subCategory: 'sleds',
        urlCategory: 'football',
        urlSubCategory: 'sleds',
        image: "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2F2-man-bull-sled-9902-HQ1.jpg?alt=media&token=27b356ea-e31d-47e9-aa99-1bc43af1c665",
        images: [
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2F2-man-bull-sled-9902-HQ1.jpg?alt=media&token=27b356ea-e31d-47e9-aa99-1bc43af1c665",
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fbull-sled-detail-HQ1.jpg?alt=media&token=7ecee020-fb6f-48df-bb68-3fec74127435",
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fbull-sled-detail-HQ2.jpg?alt=media&token=0b566b56-3ab5-475a-b6d1-5cf310481478",
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fbull-sled-pads-HQ1.jpg?alt=media&token=ed145626-ef13-4b5a-97f2-2d10ad0e5fe8"
        ]
    },{
        id: 'p46',
        name: '3 Man Bull Sled',
        sku: '9903',
        description: `Main Frame:Tough, durable and guaranteed for five years. Full 5 year warranty on metal parts. All metal surfaces are powder coated to prevent rust. Skids: Sled skids are formed, not cut and welded. 30 degree angles assure a smooth transition over our grass or artificial turf.`,
        details: [
            'SKU: 9903M',
            '5 Year guarantee',
            `Won't chew up grass or artificial turf`,
            'Powder coated to prevent rust',
            'Weight: 704 lbs'
        ],
        options: [
            '9903M: Man Pad',
            '9903BT: T Pad',
            '9903ZP: Zone Pad',
            '9903PP: Pummel Pad'
        ],
        category: 'football',
        subCategory: 'sleds',
        urlCategory: 'football',
        urlSubCategory: 'sleds',
        image: "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2F3-man-bull-sled-9903-HQ1.jpg?alt=media&token=ff6b4fc5-3b08-4372-9980-4c60b2302e33",
        images: [
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2F3-man-bull-sled-9903-HQ1.jpg?alt=media&token=ff6b4fc5-3b08-4372-9980-4c60b2302e33",
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fbull-sled-detail-HQ1.jpg?alt=media&token=7ecee020-fb6f-48df-bb68-3fec74127435",
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fbull-sled-detail-HQ2.jpg?alt=media&token=0b566b56-3ab5-475a-b6d1-5cf310481478",
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fbull-sled-pads-HQ1.jpg?alt=media&token=ed145626-ef13-4b5a-97f2-2d10ad0e5fe8"
        ]
    },{
        id: 'p47',
        name: '4 Man Bull Sled',
        sku: '9904',
        description: `Main Frame:Tough, durable and guaranteed for five years. Full 5 year warranty on metal parts. All metal surfaces are powder coated to prevent rust. Skids: Sled skids are formed, not cut and welded. 30 degree angles assure a smooth transition over our grass or artificial turf.`,
        details: [
            'SKU: 9904M',
            '5 Year guarantee',
            `Won't chew up grass or artificial turf`,
            'Powder coated to prevent rust',
            'Weight: 953 lbs'
        ],
        options: [
            '9904M: Man Pad',
            '9904BT: T Pad',
            '9904ZP: Zone Pad',
            '9904PP: Pummel Pad'
        ],
        category: 'football',
        subCategory: 'sleds',
        urlCategory: 'football',
        urlSubCategory: 'sleds',
        image: "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2F4-man-bull-sled-9904-HQ1.jpg?alt=media&token=019b0919-25bf-4971-82c1-03941460b184",
        images: [
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2F4-man-bull-sled-9904-HQ1.jpg?alt=media&token=019b0919-25bf-4971-82c1-03941460b184",
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fbull-sled-detail-HQ1.jpg?alt=media&token=7ecee020-fb6f-48df-bb68-3fec74127435",
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fbull-sled-detail-HQ2.jpg?alt=media&token=0b566b56-3ab5-475a-b6d1-5cf310481478",
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fbull-sled-pads-HQ1.jpg?alt=media&token=ed145626-ef13-4b5a-97f2-2d10ad0e5fe8"
        ]
    },{
        id: 'p48',
        name: '5 Man Bull Sled',
        sku: '9905',
        description: `Main Frame:Tough, durable and guaranteed for five years. Full 5 year warranty on metal parts. All metal surfaces are powder coated to prevent rust. Skids: Sled skids are formed, not cut and welded. 30 degree angles assure a smooth transition over our grass or artificial turf.`,
        details: [
            'SKU: 9905M',
            '5 Year guarantee',
            `Won't chew up grass or artificial turf`,
            'Powder coated to prevent rust',
            'Weight: 1203 lbs'
        ],
        options: [
            '9905M: Man Pad',
            '9905BT: T Pad',
            '9905ZP: Zone Pad',
            '9905PP: Pummel Pad'
        ],
        category: 'football',
        subCategory: 'sleds',
        urlCategory: 'football',
        urlSubCategory: 'sleds',
        image: "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2F5-man-bull-sled-9905-HQ1.jpg?alt=media&token=c3c376ca-d239-446c-98bf-cb2eccd51d94",
        images: [
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2F5-man-bull-sled-9905-HQ1.jpg?alt=media&token=c3c376ca-d239-446c-98bf-cb2eccd51d94",
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fbull-sled-detail-HQ1.jpg?alt=media&token=7ecee020-fb6f-48df-bb68-3fec74127435",
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fbull-sled-detail-HQ2.jpg?alt=media&token=0b566b56-3ab5-475a-b6d1-5cf310481478",
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fbull-sled-pads-HQ1.jpg?alt=media&token=ed145626-ef13-4b5a-97f2-2d10ad0e5fe8"
        ]
    },{
        id: 'p49',
        name: '6 Man Bull Sled',
        sku: '9906',
        description: `Main Frame:Tough, durable and guaranteed for five years. Full 5 year warranty on metal parts. All metal surfaces are powder coated to prevent rust. Skids: Sled skids are formed, not cut and welded. 30 degree angles assure a smooth transition over our grass or artificial turf.`,
        details: [
            'SKU: 9906M',
            '5 Year guarantee',
            `Won't chew up grass or artificial turf`,
            'Powder coated to prevent rust',
            'Weight: 1452 lbs'
        ],
        options: [
            '9906M: Man Pad',
            '9906BT: T Pad',
            '9906ZP: Zone Pad',
            '9906PP: Pummel Pad'
        ],
        category: 'football',
        subCategory: 'sleds',
        urlCategory: 'football',
        urlSubCategory: 'sleds',
        image: "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2F6-man-bull-sled-9906-HQ1.jpg?alt=media&token=dada3d8b-9280-43a4-9f0b-cb9ab630e58f",
        images: [
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2F6-man-bull-sled-9906-HQ1.jpg?alt=media&token=dada3d8b-9280-43a4-9f0b-cb9ab630e58f",
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fbull-sled-detail-HQ1.jpg?alt=media&token=7ecee020-fb6f-48df-bb68-3fec74127435",
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fbull-sled-detail-HQ2.jpg?alt=media&token=0b566b56-3ab5-475a-b6d1-5cf310481478",
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fbull-sled-pads-HQ1.jpg?alt=media&token=ed145626-ef13-4b5a-97f2-2d10ad0e5fe8"
        ]
    },{
        id: 'p50',
        name: '7 Man Bull Sled',
        sku: '9907',
        description: `Main Frame:Tough, durable and guaranteed for five years. Full 5 year warranty on metal parts. All metal surfaces are powder coated to prevent rust. Skids: Sled skids are formed, not cut and welded. 30 degree angles assure a smooth transition over our grass or artificial turf.`,
        details: [
            'SKU: 9907M',
            '5 Year guarantee',
            `Won't chew up grass or artificial turf`,
            'Powder coated to prevent rust',
            'Weight: 1701 lbs'
        ],
        options: [
            '9907M: Man Pad',
            '9907BT: T Pad',
            '9907ZP: Zone Pad',
            '9907PP: Pummel Pad'
        ],
        category: 'football',
        subCategory: 'sleds',
        urlCategory: 'football',
        urlSubCategory: 'sleds',
        image: "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2F7-man-bull-sled-9907-HQ1.jpg?alt=media&token=4ec8b81d-0120-4e45-ab48-eefd63352935",
        images: [
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2F7-man-bull-sled-9907-HQ1.jpg?alt=media&token=4ec8b81d-0120-4e45-ab48-eefd63352935",
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fbull-sled-detail-HQ1.jpg?alt=media&token=7ecee020-fb6f-48df-bb68-3fec74127435",
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fbull-sled-detail-HQ2.jpg?alt=media&token=0b566b56-3ab5-475a-b6d1-5cf310481478",
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fbull-sled-pads-HQ1.jpg?alt=media&token=ed145626-ef13-4b5a-97f2-2d10ad0e5fe8"
        ]
    },{
        id: 'p51',
        name: 'Indoor Bull Station',
        sku: '9900ps',
        description: `Platform and Bull Mechanism. Offensive lineman learn the progression of staying low and rolling their hips to maximize power and drive through their opponents . Defensive players work on proper footwork and striking an opponent with their hands. Advantages of the Bull: Change resistance, Resistance stays constant throughout entire motion , 6' inward/15' upward compression.`,
        details: [
            'SKU: 9900PS',
            '6" inward / 15" upward compression',
            'Resistance stays constant throughout entire motion',
            'Resistance can be changed'
        ],
        options: [
            '9900PS: Platform and Bull Mechanism',
            '9900P: Platform only'
        ],
        category: 'football',
        subCategory: 'strength and speed',
        urlCategory: 'football',
        urlSubCategory: 'strength and speed',
        image: "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Findoor-bull-station-9900PS-HQ1.jpg?alt=media&token=fb6d5484-897e-4ebd-8fb3-17f09c54d394",
        images: [
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Findoor-bull-station-9900PS-HQ1.jpg?alt=media&token=fb6d5484-897e-4ebd-8fb3-17f09c54d394",
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Findoor-bull-station-9900ps-HQ2.jpg?alt=media&token=0b1b4abe-bfeb-483f-8b2c-243facc7c75e"
        ]
    },{
        id: 'p52',
        name: 'Combat Sled',
        sku: '9301cs',
        description: `Helps develop upper and lower body strength. Large diameter round steel piping assures smooth transition over grass. Live action spring makes player work hard to take sled to ground. No sharp edges gives added safety to players. Rubber foam grip around face of sled allows for solid and safe grip while using sled.`,
        details: [
            'SKU: 9301CS',
            'Transitions smoothly over grass',
            'Builds upper and lower body strength',
            'Live action spring makes player work hard to take sled to the ground'
        ],
        options: [
            '9201CS: Combat Sled w/ 9201 base',
            '9301CS: Combat Sled w/ 9301 base',
            '9910CS: Combat Sled w/ Rush Sled base'
        ],
        category: 'football',
        subCategory: 'sleds',
        urlCategory: 'football',
        urlSubCategory: 'sleds',
        image: "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fcombat-sled-9301cs-HQ1.jpg?alt=media&token=5c4e19e9-c1ec-4360-ac02-58659a6e5d23",
        images: [
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fcombat-sled-9301cs-HQ1.jpg?alt=media&token=5c4e19e9-c1ec-4360-ac02-58659a6e5d23",
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fcombat-sled-9301cs-HQ2.jpg?alt=media&token=7394df2c-1c19-4ae6-a796-fdd00f44536f"
        ]
    },{
        id: 'p53',
        name: 'Traditional Goal Post Pad',
        sku: 'gppl1',
        description: `One color lettering, sewn onto the pad. Up to 8 letters per pad. Letters and vinyl available in 17 color options. These come in two closure styles. The Varsity series is a wrap style cover with top and bottom protection that increases durability The PRO series is a fully encased vinyl cover which keeps the foam dry and in perfect shape guaranteeing maximum lifespan. Both styles have a velcro flap in the back for closure. All of our goal post pads meet NCAA and NFHS safety standards. Heavy-duty, 18 ounce coated vinyl nylon covers. Solid polyfoam cylinder with a center cutout to match your goal (please provide pole diameter or circumference when ordering). For custom logos you will want to choose the Elite or Classic style pads. School logos or promotionals are all available from Fisher.`,
        details: [
            'SKU: GPPL1',
            'One color lettering',
            'Letters are sewn onto the pad',
            'Up to 8 letters per pad',
            'Letters and vinyl available in 17 color options'
        ],
        options: [
            `GPP400/401: 6'H x 13"Diam`,
            `GPP300/301: 6'H x 18"Diam`,
            `GPP200/201: 6'H x 22"Diam`,
            `GPP4007/4017: 7'H x 13"Diam`,
            `GPP3007/3017: 7'H x 18"Diam`,
            `GPP2007/2017: 7'H x 22"Diam`
        ],
        category: 'football',
        subCategory: 'field',
        urlCategory: 'football',
        urlSubCategory: 'field',
        image: "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fgoal-post-pad-gppl1-HQ1.jpg?alt=media&token=151ee26e-09fc-40b7-9c0d-03c13935fd14",
        images: [
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fgoal-post-pad-gppl1-HQ1.jpg?alt=media&token=151ee26e-09fc-40b7-9c0d-03c13935fd14",
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fgoal-post-pad-gppl1-HQ2.jpg?alt=media&token=4326baae-d449-40e5-9808-b8c2b3c5fa9f",
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fgoal-post-pad-cover-chart-HQ1.jpg?alt=media&token=4a522db6-d615-4811-b49d-799784af64a2",
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fgoal-post-pad-chart-HQ1.jpg?alt=media&token=27de2377-b7c3-4d26-9bb6-db31a3ecb349"
        ]
    },{
        id: 'p54',
        name: 'Traditional Goal Post Pad',
        sku: 'gppl2',
        description: `Two color lettering, sewn onto the pad. Up to 8 letters per pad. Letters and vinyl available in 17 color options. These come in two closure styles. The Varsity series is a wrap style cover with top and bottom protection that increases durability The PRO series is a fully encased vinyl cover which keeps the foam dry and in perfect shape guaranteeing maximum lifespan. Both styles have a velcro flap in the back for closure. All of our goal post pads meet NCAA and NFHS safety standards. Heavy-duty, 18 ounce coated vinyl nylon covers. Solid polyfoam cylinder with a center cutout to match your goal (please provide pole diameter or circumference when ordering). For custom logos you will want to choose the Elite or Classic style pads. School logos or promotionals are all available from Fisher.`,
        details: [
            'SKU: GPPL2',
            'Two color lettering',
            'Letters are sewn onto the pad',
            'Up to 8 letters per pad',
            'Letters and vinyl available in 17 color options'
        ],
        options: [
            `GPP400/401: 6'H x 13"Diam`,
            `GPP300/301: 6'H x 18"Diam`,
            `GPP200/201: 6'H x 22"Diam`,
            `GPP4007/4017: 7'H x 13"Diam`,
            `GPP3007/3017: 7'H x 18"Diam`,
            `GPP2007/2017: 7'H x 22"Diam`
        ],
        category: 'football',
        subCategory: 'field',
        urlCategory: 'football',
        urlSubCategory: 'field',
        image: "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fgoal-post-pad-gppl2-HQ1.jpg?alt=media&token=4bc21117-3ecc-4192-85ef-7bda6a5ec58c",
        images: [
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fgoal-post-pad-gppl2-HQ1.jpg?alt=media&token=4bc21117-3ecc-4192-85ef-7bda6a5ec58c",
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fgoal-post-pad-gppl2-HQ3.jpg?alt=media&token=a3382a4f-1178-4871-aa40-afd36b277623",
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fgoal-post-pad-cover-chart-HQ1.jpg?alt=media&token=4a522db6-d615-4811-b49d-799784af64a2",
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fgoal-post-pad-chart-HQ1.jpg?alt=media&token=27de2377-b7c3-4d26-9bb6-db31a3ecb349",
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fgoal-post-pad-gppl2-HQ2.jpg?alt=media&token=bfce90f4-e797-4189-8ac6-dcae4f8d524a",
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fgoal-post-pad-gppl2-HQ5.jpg?alt=media&token=ad4bee03-3922-4fc9-a89f-a6a69db9bb60"
        ]
    },{
        id: 'p55',
        name: 'Classic Goal Post Pad',
        sku: 'gpplldp',
        description: `Multi-colored lettering and logos printed on All of our goal post pads meet NCAA and NFHS safety standards. Heavy-duty, 18 ounce coated vinyl nylon covers. Solid polyfoam cylinder with a center cutout to match your goal (please provide pole diameter or circumference when ordering). Custom Logos: Add special logos to your Goal Post Pad(s) or Goal Post Pad Cap(s). School logos or promotionals are all available from Fisher. PRICING VARIES DEPENDING ON ART STYLE. CALL FOR YOUR QUOTE!`,
        details: [
            'SKU: GPPLLDP',
            'Multi-colored lettering and logos',
            'Lettering and logos are printed on pad',
            'Solid background in one of our 17 vinyl colors'
        ],
        options: [
            `GPP400/401: 6'H x 13"Diam`,
            `GPP300/301: 6'H x 18"Diam`,
            `GPP200/201: 6'H x 22"Diam`,
            `GPP4007/4017: 7'H x 13"Diam`,
            `GPP3007/3017: 7'H x 18"Diam`,
            `GPP2007/2017: 7'H x 22"Diam`
        ],
        category: 'football',
        subCategory: 'field',
        urlCategory: 'football',
        urlSubCategory: 'field',
        image: "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fgoal-post-pad-gpplldp-HQ1.jpg?alt=media&token=1e3cb80b-8b56-47cb-9709-a68db6c8b970",
        images: [
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fgoal-post-pad-gpplldp-HQ1.jpg?alt=media&token=1e3cb80b-8b56-47cb-9709-a68db6c8b970",
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fgoal-post-pad-gpplldp-HQ2.jpg?alt=media&token=fb9322c3-1dc6-4bd4-a526-1ef5d75cde2a",
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fgoal-post-pad-cover-chart-HQ1.jpg?alt=media&token=4a522db6-d615-4811-b49d-799784af64a2",
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fgoal-post-pad-chart-HQ1.jpg?alt=media&token=27de2377-b7c3-4d26-9bb6-db31a3ecb349",
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fgoal-post-pad-gpplldp-HQ3.jpg?alt=media&token=01296499-14d8-4a07-894a-f4b254f7fb05"
        ]
    },{
        id: 'p56',
        name: 'Elite Goal Post Pad',
        sku: 'gppedp',
        description: `360 degree fully digital print graphics with unlimited colors. Pads printed with detailed, vibrant graphics that are sure to impress fans and opposing teams. This is the ultimate way to show off your schools brand. All of our goal post pads meet NCAA and NFHS safety standards. Heavy-duty, 18 ounce coated vinyl nylon covers. Solid polyfoam cylinder with a center cutout to match your goal (please provide pole diameter or circumference when ordering). Custom Logos: Add special logos to your Goal Post Pad(s) or Goal Post Pad Cap(s). School logos or promotionals are all available from Fisher. PRICING VARIES DEPENDING ON ART STYLE. CALL FOR YOUR QUOTE!`,
        details: [
            'SKU: GPPEDP',
            '360˚ fully digitally printed graphics',
            'Unlimited colors'
        ],
        options: [
            `GPP400/401: 6'H x 13"Diam`,
            `GPP300/301: 6'H x 18"Diam`,
            `GPP200/201: 6'H x 22"Diam`,
            `GPP4007/4017: 7'H x 13"Diam`,
            `GPP3007/3017: 7'H x 18"Diam`,
            `GPP2007/2017: 7'H x 22"Diam`
        ],
        category: 'football',
        subCategory: 'field',
        urlCategory: 'football',
        urlSubCategory: 'field',
        image: "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fgoal-post-pad-gppedp-HQ1.jpg?alt=media&token=cf157289-716e-40bd-a970-cbc438534306",
        images: [
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fgoal-post-pad-gppedp-HQ1.jpg?alt=media&token=cf157289-716e-40bd-a970-cbc438534306",
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fgoal-post-pad-gppedp-HQ2.jpg?alt=media&token=7bf2fdb9-0262-44b4-974d-e81cf58df282",
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fgoal-post-pad-cover-chart-HQ1.jpg?alt=media&token=4a522db6-d615-4811-b49d-799784af64a2",
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fgoal-post-pad-chart-HQ1.jpg?alt=media&token=27de2377-b7c3-4d26-9bb6-db31a3ecb349"
        ]
    },{
        id: 'p57',
        name: 'Goal Post Pad Cap',
        sku: 'gppc',
        description: `Foam padded cap sits on top of any goal post pad. Add special logos to your Goal Post Pads or Goal Post Pad Caps. School logos or promotionals are all available from Fisher.`,
        details: [
            'SKU: GPPC',
            'Great for advertising',
            'Sits on top of your goal post pad'
        ],
        options: [
            `GPPC13: 12"H x 13"Diam`,
            `GPPC18: 12"H x 18"Diam`,
            `GPPC22: 12"H x 22"Diam`
        ],
        category: 'football',
        subCategory: 'field',
        urlCategory: 'football',
        urlSubCategory: 'field',
        image: "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fgoal-post-pad-cap-gppc-HQ3.jpg?alt=media&token=f793d355-27bd-4166-a3ed-60e1d17824f0",
        images: [
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fgoal-post-pad-cap-gppc-HQ3.jpg?alt=media&token=f793d355-27bd-4166-a3ed-60e1d17824f0",
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fgoal-post-pad-cap-gppc-HQ1.jpg?alt=media&token=a25e4aba-a72d-4a94-be08-df0654691027",
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fgoal-post-pad-cap-gppc-HQ2.jpg?alt=media&token=f64807ba-b1b2-4ea7-ba2e-a66aab3708c9"
        ]
    },{
        id: 'p58',
        name: 'Yellow Goal Post',
        sku: 'gppcy',
        description: `Powder coated yellow.`,
        details: [
            'SKU: GPPCY',
            'Primed and ready to paint',
            'Windstreamers included (WS3)',
            'Sold in pairs',
            'Ships via truck'
        ],
        options: [
            `See Goal Post chart in images for option details`,
            `High School: GP1, GP130, GP3, GP3PRO30, GP3-830`,
            `College: GP2E, GP2, GP230, GP4, GP4PRO30, GP4-830`
        ],
        category: 'football',
        subCategory: 'field',
        urlCategory: 'football',
        urlSubCategory: 'field',
        image: "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fgoal-post-yellow-gppcy-HQ1.jpg?alt=media&token=349a741a-fda6-4707-b979-4431ecb80c1b",
        images: [
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fgoal-post-yellow-gppcy-HQ1.jpg?alt=media&token=349a741a-fda6-4707-b979-4431ecb80c1b",
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fgoal-post-yellow-gppcy-HQ2.jpg?alt=media&token=f3062c05-baad-4b5b-b0a1-b0e4ca671e96",
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fwindstreamer-ws3-HQ1.jpg?alt=media&token=590a2692-b6c9-47f0-8cda-b87d70818a2c",
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fgoal-post-sizing-chart-HQ1.jpg?alt=media&token=01da4fe1-7b78-4c93-9698-af23df2625fa"
        ]
    },{
        id: 'p59',
        name: 'White Goal Post',
        sku: 'gppcw',
        description: `Powder coated white.`,
        details: [
            'SKU: GPPCW',
            'Primed and ready to paint',
            'Windstreamers included (WS3)',
            'Sold in pairs',
            'Ships via truck'
        ],
        options: [
            `See Goal Post chart in images for option details`,
            `High School: GP1, GP130, GP3, GP3PRO30, GP3-830`,
            `College: GP2E, GP2, GP230, GP4, GP4PRO30, GP4-830`
        ],
        category: 'football',
        subCategory: 'field',
        urlCategory: 'football',
        urlSubCategory: 'field',
        image: "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fgoal-post-white-gppcw-HQ1.jpg?alt=media&token=16b4ee87-b563-4085-80ae-eb5949609d6c",
        images: [
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fgoal-post-white-gppcw-HQ1.jpg?alt=media&token=16b4ee87-b563-4085-80ae-eb5949609d6c",
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fgoal-post-white-gppcw-HQ2.jpg?alt=media&token=6ea19ba8-467d-47cc-a91a-87fee228e806",
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fwindstreamer-ws3-HQ1.jpg?alt=media&token=590a2692-b6c9-47f0-8cda-b87d70818a2c",
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fgoal-post-sizing-chart-HQ1.jpg?alt=media&token=01da4fe1-7b78-4c93-9698-af23df2625fa"
        ]
    },{
        id: 'p60',
        name: 'Portable Goal Post',
        sku: '6000pgh',
        description: `Ideal for multi-purpose fields. Quickly and easily installed. Wheels allow complete mobility. 2' Outside Diameter galvanized steel. Portable goal sold each. Wind streamers included. We recommend PMV7216 or GPP400 pads on our Portable and H style Goals for safety.`,
        details: [
            'SKU: 6000PGH',
            'Ideal for multi-purpose fields',
            'Quickly and easily installed',
            'Wheels allow complete mobility to roll on and off the field',
            '2" O.D galvanized steel',
            'Portable goal sold each',
            'Windstreamers included'
        ],
        options: [
            `6000PGC: College Goal: 20'H x 18'6"W`,
            `6000PGH: High School Goal: 20'H x 23'4"W`,
            `6000PGC1: College Goal with 18' x 21' Net and 3 Targets and 1 Upright Set`,
            `6000PGH2: High School Goal with 23' x 21' Net and 3 Targets and 1 Upright Set`,
            `6000CNET: 18' x 21' Net only`,
            `6000HNET: 23' x 21' Net only`,
            `6000TARGETS: 3 Targets: 1 Triangle, 1 Round, and 1 Rectangle`,
            `6000UPRIGHTS: 1 Set of Movable Uprights 8'H x 8"W`
        ],
        category: 'football',
        subCategory: 'field',
        urlCategory: 'football',
        urlSubCategory: 'field',
        image: "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fportable-goal-post-HQ1.jpg?alt=media&token=c11a395b-efe7-44e7-991e-62f18fb8af4c",
        images: [
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fportable-goal-post-HQ1.jpg?alt=media&token=c11a395b-efe7-44e7-991e-62f18fb8af4c",
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fportable-goal-post-targets-HQ1.jpg?alt=media&token=d09e6909-1f04-4051-93a2-7d8aa6db4e5b",
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fportable-goal-post-wheels-HQ1.jpg?alt=media&token=c6295213-7499-4d37-a951-05e5a1823be2",
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fportable-goal-pos-no-net-HQ1.jpg?alt=media&token=08293056-21d6-40a4-9175-f6249beef402",
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fwindstreamer-ws3-HQ1.jpg?alt=media&token=590a2692-b6c9-47f0-8cda-b87d70818a2c"
        ]
    },{
        id: 'p61',
        name: 'H-Style Goal',
        sku: '6000hgh',
        description: `Easily installed and removed. Ideal for practice facilities. Includes ground sleeves and wind streamers 2 inch outside dimension galvanized steel. 10 feet high uprights 20 feet high from ground.`,
        details: [
            'SKU: 6000HGH',
            'Economical / sold separately',
            'Easily installed and removed',
            'Ideal for practice facilities',
            'Includes ground sleeves and windstreamers',
            '2" O.D galvanized steel',
            `10' high uprights / 20' high from ground`
        ],
        options: [
            `6000HCH: College Goal: 20'H x 18'6"W`,
            `6000HGH: High School Goal: 20'H x 23'4"W`
        ],
        category: 'football',
        subCategory: 'field',
        urlCategory: 'football',
        urlSubCategory: 'field',
        image: "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fh-style-goal-6000hgh-HQ1.jpg?alt=media&token=296e6784-7c83-431e-b0b6-9dba8a1383f5",
        images: [
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fh-style-goal-6000hgh-HQ1.jpg?alt=media&token=296e6784-7c83-431e-b0b6-9dba8a1383f5",
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fwindstreamer-ws3-HQ1.jpg?alt=media&token=590a2692-b6c9-47f0-8cda-b87d70818a2c"
        ]
    },{
        id: 'p62',
        name: 'Half Round Dummies',
        sku: 'hr426',
        description: `Curved surface reduces ankle injuries and improves player safety. Dual purpose dummy for step-over or blocking. Web handles allow you to use it as a regular blocking dummy. Half round speed dummy is designed to increase foot speed.`,
        details: [
            'SKU: HR426',
            'Curved surface reduces ankle injuries and improves player safety',
            'Dual purpose dummy for stepover or blocking',
            'Web handles allow you to use it as a regular blocking dummy',
            'Designed to increase foot speed'
        ],
        options: [
            `HR426: 42"L x 12"W x 6"H (11lbs)`,
            `HR428: 42"L x 16"W x 8"H (17lbs)`,
            `HR488: 48"L x 16"W x 8"H (20lbs)`,
            `HR4212: 42"L x 16"W x 12"H (10lbs)`
        ],
        category: 'football',
        subCategory: 'dummies',
        urlCategory: 'football',
        urlSubCategory: 'dummies',
        image: "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fhalf-round-dummies-HQ1.jpg?alt=media&token=f0ef0bfb-b129-4935-b987-106a395237a9",
        images: [
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fhalf-round-dummies-HQ1.jpg?alt=media&token=f0ef0bfb-b129-4935-b987-106a395237a9",
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fhalf-round-dummies-HQ2.jpg?alt=media&token=d68a4f9e-a2c1-49cf-82c0-d81d81ef9bb6",
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fhalf-round-dummies-HQ3.jpg?alt=media&token=4e43498b-fc5b-4b4c-a245-e15fb4f07e3e"
        ]
    },{
        id: 'p63',
        name: 'Step Over Dummies',
        sku: 'so424',
        description: `Increases player agility. Stay-in-place trapezoidal design. Backside handles for stand up practice. Special design helps reduce ankle injuries. End handle for moving on and off field.`,
        details: [
            'SKU: SO424',
            'Increases player agility',
            'Stay-in-place trapezoidal design',
            'Backside handles for stand up practice',
            'Special design helps reduce ankle injuries',
            'End handle for moving on and off field'
        ],
        options: [
            `SO424: 42"L x 4'H x 12" Base x 9" Top (10lbs)`,
            `SO426: 42"L x 6'H x 15" Base x 10" Top (14lbs)`,
            `SO488: 48"L x 8'H x 17" Base x 11" Top (20lbs)`,
            `SO4838: 48"L x 10'H x 17" Base x 12" Top (40lbs)`,
            `SO4810: 48"L x 12'H x 17" Base x 11" Top (30lbs)`
        ],
        category: 'football',
        subCategory: 'dummies',
        urlCategory: 'football',
        urlSubCategory: 'dummies',
        image: "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fstep-over-dummies-HQ1.jpg?alt=media&token=569aa47e-3b3b-4abd-8e9e-3f632cf9ccd5",
        images: [
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fstep-over-dummies-HQ1.jpg?alt=media&token=569aa47e-3b3b-4abd-8e9e-3f632cf9ccd5",
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fstep-over-dummies-HQ2.jpg?alt=media&token=5f2c31ff-ffa0-4473-b3af-19127b884ef3",
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fstep-over-dummies-HQ3.jpg?alt=media&token=568bc9ea-a3e8-4612-a267-785069540b56",
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fstep-over-dummies-HQ4.jpg?alt=media&token=ecf0ac13-29d2-4b6f-9abb-60b791cb4396"
        ]
    },{
        id: 'p64',
        name: 'Square Dummies',
        sku: 'sd14',
        description: `Increases player agility. Square design. Backside handles for stand up practice. End handle for moving on and off field.`,
        details: [
            'SKU: SD14',
            'Increases player agility',
            'Square design',
            'Backside handles for stand up practice',
            'End handle for moving on and off field'
        ],
        options: [
            `SD14: 50"L x 14"H x 14"Base x 14"Top (14 lbs)`,
            `SD15: 46"L x 15"H x 15"Base x 15"Top (40 lbs)`
        ],
        category: 'football',
        subCategory: 'dummies',
        urlCategory: 'football',
        urlSubCategory: 'dummies',
        image: "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fsquare-dummies-HQ1.jpg?alt=media&token=9f4472dd-e206-4387-81f9-6686427a8fd5",
        images: [
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fsquare-dummies-HQ1.jpg?alt=media&token=9f4472dd-e206-4387-81f9-6686427a8fd5",
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fsquare-dummies-HQ2.jpg?alt=media&token=6ba68b81-847a-474e-a104-3b93a1485386",
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fsquare-dummies-HQ3.jpg?alt=media&token=9fb62a31-85e0-4063-8a23-2c0166674e35"
        ]
    },{
        id: 'p65',
        name: 'Direct Step',
        sku: 'so4818ds',
        description: `This specially designed step-over has color-coded directional step arrows and is designed to improve a player's agility and mobility. The step-over top has three sets of multi-colored arrows which allow players to react (step) to colored cadence calls. Designed by John Fitz of Catawba College.`,
        details: [
            'SKU: SO4818DS',
            'Stepover with colored directional arrows',
            'Increases player agility',
            'Backside handles for stand up practice',
            'End handle for moving on and off field'
        ],
        options: [
            `SO4818DS: 48"L x 8"H x 18"Base x 8"Top (21 lbs)`
        ],
        category: 'football',
        subCategory: 'dummies',
        urlCategory: 'football',
        urlSubCategory: 'dummies',
        image: "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fdirect-step-HQ1.jpg?alt=media&token=0fff068e-6f7b-44fd-a703-23442b1bc0ff",
        images: [
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fdirect-step-HQ1.jpg?alt=media&token=0fff068e-6f7b-44fd-a703-23442b1bc0ff",
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fdirect-step-HQ2.jpg?alt=media&token=9bbea076-5d3a-4a51-b40f-054bcb4eb0bb",
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fdirect-step-HQ3.jpg?alt=media&token=d7893be0-8ab9-444f-924d-b340062f42d2"
        ]
    },{
        id: 'p66',
        name: 'Deluxe Windstreamer',
        sku: 'ws3d',
        description: `Know the direction of the wind with our goal post Windstreamers. Simply attach to the top of the goal post uprights. Fits on all goal posts.`,
        details: [
            'SKU: WS3D',
            'Double ply vinyl',
            'Chrome snap hook',
            'Fits all goal posts'
        ],
        options: [
            `WS3D: Deluxe Windstreamer`,
            `WS3: Windstreamer`
        ],
        category: 'football',
        subCategory: 'field',
        urlCategory: 'football',
        urlSubCategory: 'field',
        image: "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fwindstreamer-deluxe-ws3d-HQ1.jpg?alt=media&token=f5b77b2b-7d33-46b0-9a76-b8e676975d19",
        images: [
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fwindstreamer-deluxe-ws3d-HQ1.jpg?alt=media&token=f5b77b2b-7d33-46b0-9a76-b8e676975d19",
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fwindstreamer-flowing-HQ1.jpg?alt=media&token=a2a7c2d6-089f-40b1-b1ee-dd238dd41d3d"
        ]
    },{
        id: 'p67',
        name: 'Windstreamer',
        sku: 'ws3',
        description: `Know the direction of the wind with our goal post Windstreamers. Simply attach to the top of the goal post uprights. Fits on all goal posts.`,
        details: [
            'SKU: WS3',
            'Single ply vinyl',
            'Brass grommet',
            'Fits all goal posts'
        ],
        options: [
            `WS3: Windstreamer`,
            `WS3D: Deluxe Windstreamer`
        ],
        category: 'football',
        subCategory: 'field',
        urlCategory: 'football',
        urlSubCategory: 'field',
        image: "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fwindstreamer-ws3-HQ1.jpg?alt=media&token=590a2692-b6c9-47f0-8cda-b87d70818a2c",
        images: [
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fwindstreamer-ws3-HQ1.jpg?alt=media&token=590a2692-b6c9-47f0-8cda-b87d70818a2c",
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fwindstreamer-flowing-HQ1.jpg?alt=media&token=a2a7c2d6-089f-40b1-b1ee-dd238dd41d3d"
        ]
    },{
        id: 'p68',
        name: 'Bull Rush Sled',
        sku: '9910',
        description: `Unique forward slant blocking head with release mechanism allows an individual player to engage, control, drive, and extend upwards all in the same drill. Teach your defensive linemen and linebackers to shed blocks and target running back. The pad drives in 8", then releases upward, simulating real time game action for your players. Wider 52" base keeps sleds stable and extended pad allows players to react off pad and get up field. Powder coated steel for maximum weather resistance and durability.`,
        details: [
            'SKU: 9910M',
            '5 Year guarantee',
            `Won't chew up grass or artificial turf`,
            'Powder coated to prevent rust',
            'Weight: 325 lbs'
        ],
        options: [
            '9910M: Man Pad',
            '9910BT: "T" Pad',
            '9910MGP: Man Grab Pad',
            '9910PP: Pummel Pad',
            '9000WH: Sled Weight Horn that can be added to any 9900 series sled. (horn holds up to four 45lb weights)'
        ],
        category: 'football',
        subCategory: 'sleds',
        urlCategory: 'football',
        urlSubCategory: 'sleds',
        image: "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fbull-rush-sled-man-pad-9910m-HQ1.jpg?alt=media&token=469378c0-9966-449e-9469-cb3833f6227e",
        images: [
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fbull-rush-sled-man-pad-9910m-HQ1.jpg?alt=media&token=469378c0-9966-449e-9469-cb3833f6227e",
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fbull-rush-sled-t-pad-9910bt-HQ1.jpg?alt=media&token=553be214-6a11-40d4-ac9e-c6e87b7558fa",
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fbull-rush-sled-man-grab-pad-9910mgp-HQ1.jpg?alt=media&token=2be63e19-9221-47a8-b700-68219d6f879b",
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fbull-rush-sled-pummel-pad-9910pp-HQ1.jpg?alt=media&token=d86fe9ab-8eaa-4e8f-b4a0-68d163a4a555",
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fsled-weight-horn-9000wh-HQ1.jpg?alt=media&token=6395f887-5b9b-4d20-a37f-e09c15299772",
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fbull-rush-sled-pads-9910-HQ1.jpg?alt=media&token=f3b9deac-b8b3-4e91-8dba-840aab8f589b"
        ]
    },{
        id: 'p69',
        name: 'Punch Pad Player',
        sku: 'hpp',
        description: `Allows players to work on proper punch technique, posture, and footwork. 18 oz UV resistant coated vinyl. High grade polyfoam. Grommets on top and bottom for mounting. Can be used indoors or outdoors for year round practice.`,
        details: [
            'SKU: HPP16',
            '18 oz UV resistant coated vinyl',
            'High grade polyfoam',
            'Grommets on top and bottom for mounting',
            'Can be used indoors or outdoors',
            'Weight: 70 lbs'
        ],
        options: [
            `HPP8: 4'H x 8'W x 5" thick, 35lbs`,
            `HPP16: 4'H x 16'W x 5" thick, 70lbs`
        ],
        category: 'football',
        subCategory: 'training',
        urlCategory: 'football',
        urlSubCategory: 'training',
        image: "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fpunch-pad-player-hpp16-HD1.jpg?alt=media&token=d2d6f15a-7ec0-4150-b071-9327aafc14a6",
        images: [
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fpunch-pad-player-hpp16-HD1.jpg?alt=media&token=d2d6f15a-7ec0-4150-b071-9327aafc14a6"
        ]
    },{
        id: 'p70',
        name: 'Punch Pad Target',
        sku: 'hpt',
        description: `Allows players to work on proper punch technique, posture, and footwork. 18 oz UV resistant coated vinyl. High grade polyfoam. Grommets on top and bottom for mounting. Can be used indoors or outdoors for year round practice.`,
        details: [
            'SKU: HPT16',
            '18 oz UV resistant coated vinyl',
            'High grade polyfoam',
            'Grommets on top and bottom for mounting',
            'Can be used indoors or outdoors',
            'Weight: 70 lbs'
        ],
        options: [
            `HPT8: 4'H x 8'W x 5" thick, 35lbs`,
            `HPT16: 4'H x 16'W x 5" thick, 70lbs`
        ],
        category: 'football',
        subCategory: 'training',
        urlCategory: 'football',
        urlSubCategory: 'training',
        image: "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fpunch-pad-target-hpt16-HD1.jpg?alt=media&token=b69831ac-0662-494b-a4a3-366a50b1cc24",
        images: [
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fpunch-pad-target-hpt16-HD1.jpg?alt=media&token=b69831ac-0662-494b-a4a3-366a50b1cc24"
        ]
    },{
        id: 'p71',
        name: 'Tackle Wheel Ball Holder',
        sku: 'twbh',
        description: `Holds a football on your tackle wheel.`,
        details: [
            'SKU: TWBH',
            'Holds ball on your tackle wheel',
            'Fits any of our tackle wheels'
        ],
        options: [
            `TWBH: Tackle Wheel Ball Holder`
        ],
        category: 'football',
        subCategory: 'training',
        urlCategory: 'football',
        urlSubCategory: 'training',
        image: "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Ftackle-wheel-ball-holder-twbh-HQ1.jpg?alt=media&token=988c05c4-5f3b-4669-80a3-2f40af12b533",
        images: [
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Ftackle-wheel-ball-holder-twbh-HQ1.jpg?alt=media&token=988c05c4-5f3b-4669-80a3-2f40af12b533",
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Ftackle-wheel-ball-holder-twbh-HQ2.jpg?alt=media&token=a81989b9-8738-4d73-abde-c38abc037b10",
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Ftackle-wheel-ball-holder-twbh-HQ3.jpg?alt=media&token=d6c5e19e-5436-48b4-8b46-e45af6363723",
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Ftackle-wheel-ball-holder-twbh-HQ4.jpg?alt=media&token=8786686e-f4db-4da6-9662-17503b097dd9",
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Ftackle-wheel-ball-holder-twbh-HQ5.jpg?alt=media&token=d182d4f3-fe82-4719-877c-b19938cb4157"
        ]
    },{
        id: 'p72',
        name: 'Rocket Pursuer',
        sku: 'pur101r',
        description: `The Pursuer is a tool to help improve tackling techniques by hitting a moving target. The all foam construction makes the Pursuer the most addordable and durable moving tackle system on the market.`,
        details: [
            'SKU: PUR101R',
            'Simulates live player movement',
            'Minimize player to player contact',
            'Beginners get used to hitting a moving target',
            'Top and Base all foam construction',
            'Make your players more effective tacklers',
            'Teaching the fundamentals of football has never been easier',
            'Height: 72"',
            'Weight: 34 lbs'
        ],
        options: [
            `PUR101R: Rocket Pursuer`
        ],
        category: 'football',
        subCategory: 'training',
        urlCategory: 'football',
        urlSubCategory: 'training',
        image: "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fpursuer-rocket-pur101r-HQ1.jpg?alt=media&token=6d96a4cc-e849-474a-9e1a-a9837b7ce77d",
        images: [
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fpursuer-rocket-pur101r-HQ1.jpg?alt=media&token=6d96a4cc-e849-474a-9e1a-a9837b7ce77d",
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fpursuer-rocket-pur101r-HQ2.jpg?alt=media&token=eb96dcdc-6c23-4bcc-9d1d-34af41eaf200",
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fpursuer-rocket-pur101r-HQ3.jpg?alt=media&token=93cfc4f2-0566-4cce-b09e-defeb1e8846f",
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fpursuer-rocket-pur101r-HQ4.jpg?alt=media&token=59ae3f80-c68d-4383-8e9f-41e7780d408c"
        ]
    },{
        id: 'p73',
        name: 'Spartan Pursuer',
        sku: 'pur102s',
        description: `The Pursuer is a tool to help improve tackling techniques by hitting a moving target. The all foam construction makes the Pursuer the most addordable and durable moving tackle system on the market.`,
        details: [
            'SKU: PUR102S',
            'Simulates live player movement',
            'Minimize player to player contact',
            'Beginners get used to hitting a moving target',
            'Top and Base all foam construction',
            'Make your players more effective tacklers',
            'Teaching the fundamentals of football has never been easier',
            'Height: 62"',
            'Weight: 28 lbs'
        ],
        options: [
            `PUR102S: Spartan Pursuer`
        ],
        category: 'football',
        subCategory: 'training',
        urlCategory: 'football',
        urlSubCategory: 'training',
        image: "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fpursuer-spartan-pur102s-HQ1.jpg?alt=media&token=58217e7f-c470-492a-955e-60f2d6c78f4c",
        images: [
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fpursuer-spartan-pur102s-HQ1.jpg?alt=media&token=58217e7f-c470-492a-955e-60f2d6c78f4c",
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fpursuer-spartan-pur102s-HQ2.jpg?alt=media&token=425772ed-87e2-4915-b96e-27ef7a1dc1ba",
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fpursuer-spartan-pur102s-HQ3.jpg?alt=media&token=8c3ca09f-b2e4-45c9-8cd2-94d1c0afdd95",
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fpursuer-spartan-pur102s-HQ4.jpg?alt=media&token=ea426d5c-ef54-47be-b00f-1b5b2d877829"
        ]
    },{
        id: 'p74',
        name: 'Agility Chute',
        sku: 'agc4060',
        description: `The Agility Chute is a great way to teach backs and receivers to keep their pad level low and maintain a low center of gravity.`,
        details: [
            'SKU: AGC4060',
            'Color: Orange',
            'Height: 60"',
            'Width: 40"'
        ],
        options: [
            `AGC4060: Agility Chute`
        ],
        category: 'football',
        subCategory: 'chutes',
        urlCategory: 'football',
        urlSubCategory: 'chutes',
        image: "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fagility-chute-agc4060-HQ1.jpg?alt=media&token=de346f70-16b6-465f-a22a-239177bce978",
        images: [
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fagility-chute-agc4060-HQ1.jpg?alt=media&token=de346f70-16b6-465f-a22a-239177bce978",
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fagility-chute-agc4060-HQ3.jpg?alt=media&token=fdf986f6-30c3-4a2f-b76c-dab6b63e12f4",
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fagility-chute-agc4060-HQ4.jpg?alt=media&token=e5d0a0a1-7d58-4cfe-a5a3-024b71361c6a",
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fagility-chute-agc4060-HQ2.jpg?alt=media&token=8391d5b3-eaef-4934-91fb-a4a7e767708f"
        ]
    },{
        id: 'p75',
        name: 'Adjustable Agility Chute',
        sku: 'agcadjp',
        description: `The Adjustable Agility Chute is a great way to teach backs and receivers to keep their pad level low and maintain a low center of gravity. The Adjustable Agility Chute adjusts from 28" to 60" tall, giving you the option for many different drills.`,
        details: [
            'SKU: AGCADJP',
            'The Adjustable Agility Chute adjusts from 28" to 60" tall, giving you the option for many different drills.',
            'Height: 28" to 60" (adjustable)',
            'Width: 40"'
        ],
        options: [
            `AGCADJP: Powder Coated in White, Forest, Green, Purple, Royal, Navy, Red, Maroon, Black, Orange`,
            `AGCADJN: Natural Aluminum (silver) color`
        ],
        category: 'football',
        subCategory: 'chutes',
        urlCategory: 'football',
        urlSubCategory: 'chutes',
        image: "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fadjustable-agility-chute-agcadjp-HQ1.jpg?alt=media&token=8c22431c-1291-4004-9f3d-224e1e552d87",
        images: [
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fadjustable-agility-chute-agcadjp-HQ1.jpg?alt=media&token=8c22431c-1291-4004-9f3d-224e1e552d87",
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fadjustable-agility-chute-agcadjp-HQ2.jpg?alt=media&token=3483b422-491c-4f79-b409-3c4de79e23b7",
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fadjustable-agility-chute-agcadjp-HQ3.jpg?alt=media&token=c65bcdab-3e0f-4b76-87bc-4435d10f83b3"
        ]
    },{
        id: 'p76',
        name: 'Correct Step Configurable Chute Board',
        sku: '9670',
        description: `Fisher's molded, rigid urethane foam chute boards will not warp, crack, or splinter. All boards feature side beveling to prevent ankle injuries. Our added connector holes provide stability and allow for a variety of board alignments. Various configurations allow for multiple agility and speed drills.`,
        details: [
            'SKU: 9670',
            'Molded, rigid urethane foam chute boards will not warp, crack, or splinter',
            'Connector holes allow for a variety of board alignments',
            'Side beveling helps prevent ankle injuries',
            'Weight: 27 lbs'
        ],
        options: [
            `9670: Chute Board with "T" (3 units) : 94"x44"x2" : 27 lbs`,
            `9671: Long Chute Board (2 units) : 88"x12"x2" : 18 lbs`,
            `9672: Short Chute Board (1 unit) : 44"x12"x2" : 9 lbs`,
            `9690: 6" PVC Connector (pkg of 6) : 1 lb`,
            `9669: "T" only Chute Board : 44"x6"x2" : 6lbs`
        ],
        category: 'football',
        subCategory: 'chutes',
        urlCategory: 'football',
        urlSubCategory: 'chutes',
        image: "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fcorrect-step-configerable-chute-board-9670-HQ1.jpg?alt=media&token=8cd22f92-b372-403a-9a63-53a197b9d2d7",
        images: [
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fcorrect-step-configerable-chute-board-9670-HQ1.jpg?alt=media&token=8cd22f92-b372-403a-9a63-53a197b9d2d7",
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fcorrect-step-configerable-chute-board-9670-HQ2.jpg?alt=media&token=3c912bb5-dc79-46a3-9e53-ea30ff8e398e"
        ]
    },{
        id: 'p77',
        name: 'Correct Step',
        sku: '9665',
        description: `Work the base step, 45 degree angle step and lateral step along with the second step to get your players off the Line of Scrimmage the correct way. A must for younger players just learning the game. Eliminates coming off the Line of Scrimmage flat footed, heel placement first, raising up, over-striding, getting feet too close together, and stepping in the center of the body. Create a 6" power step that will force players to come off their toes, not their heels or flat footed. Forces players to step at a 45 degree angle for slants and position blocks(reach block, cut off block).`,
        details: [
            'SKU: 9665',
            'A must for younger players just learning the game',
            'Helps get your players off the L.O.S. the correct way',
            'Creates a 6" power step that will force players to come off their toes, not their heels or flat footed',
            'Weight: 15 lbs',
            'Size: 48"L x 18"W'
        ],
        options: [
            `9665: Correct Step`
        ],
        category: 'football',
        subCategory: 'chutes',
        urlCategory: 'football',
        urlSubCategory: 'chutes',
        image: "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fcorrect-step-9665-HQ1.jpg?alt=media&token=9bc0bfc5-ab0a-451a-9315-8660892036be",
        images: [
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fcorrect-step-9665-HQ1.jpg?alt=media&token=9bc0bfc5-ab0a-451a-9315-8660892036be",
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fcorrect-step-9665-HQ2.jpg?alt=media&token=f5691ea9-b9ac-454d-b62b-e548c935f308"
        ]
    },{
        id: 'p78',
        name: 'Chute Boards',
        sku: '9673',
        description: `Fisher's molded, rigid urethane foam chute boards will not warp, crack, or splinter. All boards feature side beveling to prevent ankle injuries. Our added connector holes provide stability and allow for a variety of board alignments. Various configurations allow for multiple agility and speed drills.`,
        details: [
            'SKU: 9673',
            'Folding Chute Board with handles',
            'High impact foam covered with Gold 18 oz vinyl',
            'Add custom logos or artwork (max artwork dimensions: 6"W x 36"L',
            'Size: 96"x12"x2"',
            'Weight: 12 lbs'
        ],
        options: [
            `9673: Folding Chute Board, 12 lbs, 96"x12"x2"`,
            `9674: Short "T", 3 lbs,44"x6"x2"`,
            `9675: "T" Set, 15 lbs, 96"x12"x2"`
        ],
        category: 'football',
        subCategory: 'chutes',
        urlCategory: 'football',
        urlSubCategory: 'chutes',
        image: "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fchute-board-folding-9673-HQ1.jpg?alt=media&token=d98cdbb7-2023-464b-a523-42bab80efd38",
        images: [
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fchute-board-folding-9673-HQ1.jpg?alt=media&token=d98cdbb7-2023-464b-a523-42bab80efd38",
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fchute-board-folding-9673-HQ2.jpg?alt=media&token=e2d477a5-8bf3-45ab-8394-9814d0a0b1aa",
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fchute-board-folding-9673-HQ3.jpg?alt=media&token=8310338b-ce50-4a61-8e66-b7fc57947c7e",
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fchute-board-short-t-9674-HQ1.jpg?alt=media&token=0031ca8b-486b-4d7b-bc8b-bc7b7b9e1c86"
        ]
    },{
        id: 'p79',
        name: 'Flex Chute',
        sku: 'fxc2712',
        description: `Largest Square Foot Chute in industry. Mesh top protects helmets from scratching. Chain mounting system allows for adjustment of angle. Teaches players in multiple positions to stay low. Flexibility of chute allows for multiple drills to be practiced.`,
        details: [
            'SKU: FXC2712',
            `Available in 6' and 12' widths`,
            `Available in 18', 27', and 36' lengths`,
            `Height adjusts from 36" to 56"`,
            `Largest sq ft chute in the industry`,
            'Weight: 840 lbs'
        ],
        options: [
            `FXC186: 18'Long x 6'Wide (620 lbs)`,
            `FXC1812: 18'Long x 12'Wide (700 lbs)`,
            `FXC276: 27'Long x 6'Wide (735 lbs)`,
            `FXC2712: 27'Long x 12'Wide (840 lbs)`,
            `FXC366: 36'Long x 6'Wide (870 lbs)`,
            `FXC3612: 36'Long x 12'Wide (995 lbs)`,
            `FXCWK: Optional weel kit (set of 4)`,
        ],
        category: 'football',
        subCategory: 'chutes',
        urlCategory: 'football',
        urlSubCategory: 'chutes',
        image: "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fflex-chute-fxc2712-HQ1.jpg?alt=media&token=f3029ed0-ce4b-459c-8238-8b41356ae23b",
        images: [
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fflex-chute-fxc2712-HQ1.jpg?alt=media&token=f3029ed0-ce4b-459c-8238-8b41356ae23b",
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fflex-chute-fxc2712-HQ2.jpg?alt=media&token=5ceb0c64-ca51-47f0-b01a-e0ec9fda3120",
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fflex-chute-fxc2712-HQ3.jpg?alt=media&token=122b8dca-3011-4123-a2cd-260aedd36097",
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fflex-chute-fxc2712-HQ4.jpg?alt=media&token=d1462b45-da5f-4b1f-a019-9bafe55e0302",
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fflex-chute-wheel-kit-fxcwk-HQ1.jpg?alt=media&token=5c4e97cc-eed7-4472-b62e-8db3220759bb"
        ]
    },{
        id: 'p80',
        name: 'Open Chute',
        sku: 'oc1010',
        description: `Aluminum construction with sturdy aluminum castings on all 4 corners. Telescoping legs for 10" of adjustability from 45" to 56". Work all directions in a good athletic football position.`,
        details: [
            'SKU: OC1010',
            `Blue vinyl mesh top`,
            `Aluminum construction`,
            `Telescoping legs for 10" of adjustability from 46" to 56" in height`,
            `Dimensions: 10' x 10'`,
            'Weight: 95 lbs'
        ],
        options: [
            `OC1010: 10' x 10' (blue vinyl mesh top) 95 lbs`,
            `OC1020: 10' x 20' (black vinyl mesh top) 190 lbs`,
            `OC105: 5' x 10' (red vinyl mesh top) 76 lbs`,
            `OCWK: Wheel Kit (fits all Open Chutes)`
        ],
        category: 'football',
        subCategory: 'chutes',
        urlCategory: 'football',
        urlSubCategory: 'chutes',
        image: "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fopen-chute-oc1010-HQ1.jpg?alt=media&token=84a63cad-9e9f-4019-a902-f004e4a7f1d1",
        images: [
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fopen-chute-oc1010-HQ1.jpg?alt=media&token=84a63cad-9e9f-4019-a902-f004e4a7f1d1",
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fopen-chute-oc1010-HQ4.jpg?alt=media&token=e0ff0af5-6151-42bd-8a4a-842da5733f37",
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fopen-chute-oc1010-HQ3.jpg?alt=media&token=b1b76a4d-df0a-4bb4-8a6c-4dfb50ee506d",
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fopen-chute-oc105-HQ1.jpg?alt=media&token=63774e99-5e5f-4567-9478-245242e4ccb4",
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fopen-chute-oc105-HQ2.jpg?alt=media&token=2be6138d-4497-4fc8-977a-236da0a2fa12",
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fopen-chute-oc105-HQ3.jpg?alt=media&token=0ea2bb2e-aaac-417c-ba97-04fc782d7f93"
        ]
    },{
        id: 'p81',
        name: 'Trap Chute',
        sku: '96520',
        description: `4' deep with adjustable height (42" to 60"). Quarterback passing drills with chute in a vertical position. One person can rotate and lock the chute angle. Durable powder coated frame. Nylon mesh "no scratch" top cover protects your players and gear.`,
        details: [
            'SKU: 96520',
            `Durable powder coated frame`,
            `Nylon mesh "no-scratch" top cover protects your players and gear`,
            `Available in 10', 15', 20', and 25' widths`,
            `Adjustable height (42" to 60")`,
            `Dimensions: 4'W x 20L'`,
            'Weight: 500 lbs'
        ],
        options: [
            `96510: 4'W x 10'L (300 lbs)`,
            `96515: 4'W x 15'L (400 lbs)`,
            `96520: 4'W x 20'L (500 lbs)`,
            `96525: 4'W x 25'L (600 lbs)`,
            `9680: Optional Wheel Kit`
        ],
        category: 'football',
        subCategory: 'chutes',
        urlCategory: 'football',
        urlSubCategory: 'chutes',
        image: "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Ftrap-chute-96520-HQ1.jpg?alt=media&token=2f752ef2-17a1-40e7-b718-95f156c13cf7",
        images: [
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Ftrap-chute-96520-HQ1.jpg?alt=media&token=2f752ef2-17a1-40e7-b718-95f156c13cf7",
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Ftrap-chute-96520-HQ2.jpg?alt=media&token=02ef09e8-37a0-4d91-b907-5413113df060",
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Ftrap-chute-96520-HQ3.jpg?alt=media&token=70df8b50-d687-4d8c-8080-09f163d247eb",
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Ftrap-chute-96520-HQ4.jpg?alt=media&token=5d4ab6cf-0cd5-47a5-90ff-0f7db29cc705",
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Ftrap-chute-96520-HQ5.jpg?alt=media&token=ba8ff447-9f15-4518-8d01-a6d0058ab801"
        ]
    },{
        id: 'p82',
        name: 'Lineman Chute',
        sku: '9635hd',
        description: `Black powder coat finish. Heavier and sturdier than competitive chutes. Double head guard helps keep player's head in proper position. Dimensions: 42" entry x 52" exit x 48" wide x 50" deep. Expandable Design. Ships truck.`,
        details: [
            'SKU: 9635HD',
            `Black powder coated finish`,
            `Heavier and sturdier than competitive chutes`,
            `Double head guard helps keep player's head in proper position`,
            `Expandable design`,
            'Weight: 380 lbs'
        ],
        options: [
            `9631HD: 1 Man Chute 4' x 4' x 5' (108 lbs)`,
            `9632HD: 2 Man Chute 8' x 4' x 5' (176 lbs)`,
            `9633HD: 3 Man Chute 12' x 4' x 5' (244 lbs)`,
            `9634HD: 4 Man Chute 16 x 4' x 5' (312 lbs)`,
            `9635HD: 5 Man Chute 20' x 4' x 5' (380 lbs)`,
            `9636HD: 6 Man Chute 24' x 4' x 5' (448 lbs)`,
            `9637HD: 7 Man Chute 28' x 4' x 5' (516 lbs)`
        ],
        category: 'football',
        subCategory: 'chutes',
        urlCategory: 'football',
        urlSubCategory: 'chutes',
        image: "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Flineman-chute-9635hd-HQ1.jpg?alt=media&token=bd8e82d7-fed7-41f3-9eb2-78ea38e413c8",
        images: [
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Flineman-chute-9635hd-HQ1.jpg?alt=media&token=bd8e82d7-fed7-41f3-9eb2-78ea38e413c8",
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Flineman-chute-9635hd-HQ2.jpg?alt=media&token=4b387db5-e9db-49ad-a35e-57b686299bad",
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Flineman-chute-9635hd-HQ3.jpg?alt=media&token=bc7be3cb-9092-4b45-b436-1d4721ea313a"
        ]
    },{
        id: 'p83',
        name: 'Power Blaster',
        sku: 'bla12hd9002m',
        description: `Teaches players to lower shoulders, explode through the defense and hold on to the ball. Great for both offensive and defensive skills. Improve quickness, agility, leg drive, ball security, and proper footwork. Increases repititions and decreases injuries. Variable resistance from 25-250 lbs per arm. Pads adjust up and down.`,
        details: [
            'SKU: BLA12HD9002M',
            'A great tool for teaching player aggresiveness and the importance of covering the ball',
            `12 arms for greater resistance`,
            `Arm height adjusts 22" to 26" from ground`,
            `Arms adjust from 25 to 250 lbs resistance each`,
            `Arms adjust in tension, height, and angle`,
            `Heavy duty steel cast parts`,
            `Choose from 3 different sled pad styles`,
            `Lifetime warranty on arms`,
            `5 year warranty on Blaster`,
        ],
        options: [
            ``
        ],
        category: 'football',
        subCategory: 'blasters',
        urlCategory: 'football',
        urlSubCategory: 'blasters',
        image: "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fpower-blaster-bla12hd9002m-HD1.jpg?alt=media&token=ba845393-9fe1-4dc0-bc37-c5de62740b89",
        images: [
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fpower-blaster-bla12hd9002m-HD1.jpg?alt=media&token=ba845393-9fe1-4dc0-bc37-c5de62740b89",
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fpower-blaster-bla12hd9002m-HD2.jpg?alt=media&token=3014a22c-c151-4bab-bc49-5e3cdc15265d",
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fpower-blaster-bla12hd9002m-HD3.jpg?alt=media&token=568c87b2-8cf7-4fa1-8a82-064e1137bea9",
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fpower-blaster-bla12hd9002m-HD4.jpg?alt=media&token=1673a993-267b-4eb1-afd6-dca741ea400b",
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fblaster-with-boomer-sled-pads-options-HQ1.jpg?alt=media&token=5e07cd5c-81af-417d-9a05-16a14e6cf4d9"
        ]
    },{
        id: 'p84',
        name: 'Blaster 12',
        sku: `blaster12`,
        description: `Teaches players to lower shoulders, explode through the defense and hold on to the ball. Great for both offensive and defensive skills. Improve quickness, agility, leg drive, ball security, and proper footwork. Increases repititions and decreases injuries. Variable resistance from 25-250 lbs per arm. Pads adjust up and down.`,
        details: [
            'SKU: BLASTER12',
            'A great tool for teaching player aggresiveness and the importance of covering the ball',
            `12 arms for greater resistance`,
            `Arm height adjusts 22" to 26" from ground`,
            `Arms adjust from 25 to 250 lbs resistance each`,
            `Arms adjust in tension, height, and angle`,
            `Heavy duty steel cast parts`,
            `Lifetime warranty on arms`,
            `5 year warranty on Blaster`,
        ],
        options: [
            ``
        ],
        category: 'football',
        subCategory: 'blasters',
        urlCategory: 'football',
        urlSubCategory: 'blasters',
        image: "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fblaster12-HQ1.jpg?alt=media&token=267a1060-4c0e-4a5a-948b-9130719488d0",
        images: [
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fblaster12-HQ1.jpg?alt=media&token=267a1060-4c0e-4a5a-948b-9130719488d0",
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fblaster12-HQ2.jpg?alt=media&token=28a29566-b762-41e1-98c5-f67e865dd16d"
        ]
    },{
        id: 'p85',
        name: 'Blaster with Hanging Dummy',
        sku: `bla12hd`,
        description: `Teaches players to lower shoulders, explode through the defense and hold on to the ball. Great for both offensive and defensive skills. Improve quickness, agility, leg drive, ball security, and proper footwork. Increases repititions and decreases injuries. Variable resistance from 25-250 lbs per arm. Pads adjust up and down.`,
        details: [
            'SKU: BLA12HD',
            'Hanging Dummy is manufactured with 18 oz coated vinyl',
            'Dummy Size: 16" Diam x 54" Tall',
            'Dummy available in (11) 18 oz vinyl colors',
            `12 arms for greater resistance`,
            `Arm height adjusts 22" to 26" from ground`,
            `Arms adjust from 25 to 250 lbs resistance each`,
            `Arms adjust in tension, height, and angle`,
            `Heavy duty steel cast parts`,
            `Lifetime warranty on arms`,
            `5 year warranty on Blaster`,
        ],
        options: [
            ``
        ],
        category: 'football',
        subCategory: 'blasters',
        urlCategory: 'football',
        urlSubCategory: 'blasters',
        image: "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fblaster-with-hanging-dummy-bla12hd-HQ1.jpg?alt=media&token=d6c5ad30-b5a4-44ea-a4c0-0f0d44f568fb",
        images: [
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fblaster-with-hanging-dummy-bla12hd-HQ1.jpg?alt=media&token=d6c5ad30-b5a4-44ea-a4c0-0f0d44f568fb",
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fblaster-with-hanging-dummy-bla12hd-HQ2.jpg?alt=media&token=093ce818-882c-4d9a-8099-a6da891b9fe9"
        ]
    },{
        id: 'p86',
        name: 'Blaster with Boomer Sled Pad',
        sku: `bla129002`,
        description: `Teaches players to lower shoulders, explode through the defense and hold on to the ball. Great for both offensive and defensive skills. Improve quickness, agility, leg drive, ball security, and proper footwork. Increases repititions and decreases injuries. Variable resistance from 25-250 lbs per arm. Pads adjust up and down.`,
        details: [
            'SKU: BLA129002',
            `12 arms for greater resistance`,
            `Arm height adjusts 22" to 26" from ground`,
            `Arms adjust from 25 to 250 lbs resistance each`,
            `Arms adjust in tension, height, and angle`,
            `Heavy duty steel cast parts`,
            `Choose from 3 different sled pad styles`,
            `Lifetime warranty on arms`,
            `5 year warranty on Blaster`,
        ],
        options: [
            `BLA129002M: Man Pad`,
            `BLA129002T: "T" Pad`,
            `BLA129002C: Cone Pad`
        ],
        category: 'football',
        subCategory: 'blasters',
        urlCategory: 'football',
        urlSubCategory: 'blasters',
        image: "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fblaster-with-boomer-sled-pads-bla129002-HQ1.jpg?alt=media&token=a1e0e11c-aaa7-44c8-ba82-51b1fb01dfd1",
        images: [
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fblaster-with-boomer-sled-pads-bla129002-HQ1.jpg?alt=media&token=a1e0e11c-aaa7-44c8-ba82-51b1fb01dfd1",
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fblaster-with-boomer-sled-pads-bla129002-HQ2.jpg?alt=media&token=fb2d91b5-f896-4b63-b0d1-b3df29b4fc39",
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fblaster-with-boomer-sled-pads-options-HQ1.jpg?alt=media&token=5e07cd5c-81af-417d-9a05-16a14e6cf4d9"
        ]
    },{
        id: 'p87',
        name: 'Blaster',
        sku: `blaster`,
        description: `Arms adjust from 25 to 250 lbs each. Arms can be locked back out of the way. Arms adjustable in tension, height and angle. Arms won't break and fall off. Heavy duty steel cast parts. Once properly assembled and installed, the original Smitty's Blaster will provide years of trouble-free service. Due to its size, the Blaster is shipped disassembled, however complete and easy to follow instructions are included. To assure that your Blaster will always be in top notch condition, we carry a complete inventory of replacement parts. To order a Blaster parts list call 1-800-438-6028. The Blaster is shipped Freight On Board Salisbury, NC.`,
        details: [
            'SKU: BLASTER',
            `Easy to set up`,
            `Arms adjust from 25 to 250 lbs each`,
            `Lifetime warranty on arms`,
            `5 year warranty on Blaster`,
        ],
        options: [
            ``
        ],
        category: 'football',
        subCategory: 'blasters',
        urlCategory: 'football',
        urlSubCategory: 'blasters',
        image: "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fblaster-HQ1.jpg?alt=media&token=82c8d10d-e197-4b7a-aa9d-1131f6a9eb99",
        images: [
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fblaster-HQ1.jpg?alt=media&token=82c8d10d-e197-4b7a-aa9d-1131f6a9eb99",
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fblaster-HQ2.jpg?alt=media&token=518c2140-c87e-4d79-b72d-4d9956b9e11a"
        ]
    },{
        id: 'p88',
        name: 'Power Frame',
        sku: `pf1021654`,
        description: `Beam height adjusts from 76" to 92". Easy set up. Heavy duty steel construction. Three different dummy options. Never-Go-Flat Wheels.`,
        details: [
            'SKU: PF1021654',
            `Beam height adjusts from 76" to 92"`,
            `Easy set up`,
            `Heavy duty steel construction`,
            `Available in 10' and 20' widths`,
            `Three different dummy options`,
            `Never-Go-Flat wheels`,
        ],
        options: [
            `PF1011654: 10ft frame + (1) 16"x54" Hanging Dummy (500 lbs)`,
            `PF1011872: 10ft frame + (1) 18"x72" Hanging Dummy (520 lbs)`,
            `PF1013860: 10ft frame + (1) 38"x60" Hanging Dummy (755 lbs)`,
            `PF1021654: 10ft frame + (2) 16"x54" Hanging Dummy (570 lbs)`,
            `PF1021872: 10ft frame + (2) 18"x72" Hanging Dummy (610 lbs)`,
            `PF2031654: 20ft frame + (3) 16"x54" Hanging Dummy (730 lbs)`,
            `PF2031872: 20ft frame + (3) 18"x72" Hanging Dummy (790 lbs)`,
            `PF2041654: 20ft frame + (4) 16"x54" Hanging Dummy (800 lbs)`,
            `PF2041872: 20ft frame + (4) 18"x72" Hanging Dummy (880 lbs)`,
            `FHD1654: "Fullback" Dummy (70 lbs) 16" Diam x 54" Tall`,
            `FHD1872: "Linebacker" Dummy (90 lbs) 18" Diam x 72" Tall`,
            `FHD3860: "Bad" Dummy (325 lbs) 38" Diam x 60" Tall`
        ],
        category: 'football',
        subCategory: 'blasters',
        urlCategory: 'football',
        urlSubCategory: 'blasters',
        image: "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fpower-frame-pf1021654-HQ1.jpg?alt=media&token=8b51e9f9-a5bd-4cd4-8a3a-5b9807b069f7",
        images: [
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fpower-frame-pf1021654-HQ1.jpg?alt=media&token=8b51e9f9-a5bd-4cd4-8a3a-5b9807b069f7",
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fpower-frame-pf1021654-HQ2.jpg?alt=media&token=fe3ccf4f-977a-405a-8ad6-2ec4a50cecae",
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fpower-frame-pf1021654-HQ3.jpg?alt=media&token=5b6f205e-a078-4428-b57c-2c72c6cc41d3"
        ]
    },{
        id: 'p89',
        name: 'The Club',
        sku: 'hd1500pr',
        description: `Practice live drills with maximum protection. Defensive lineman practice Swim/Rip/Chop. Arm slides into pad with handle inside. Individual. 24" L x 9-1/2" outside diameter.`,
        details: [
            'SKU: HD1500PR',
            'Practice live drills with maximum protection',
            'Defensive linemen practice - Swim/Rip/Chop',
            'Arm slides into pad with handles inside',
            'Standard colors: red w/ black tip; gold w/ black tip',
            '24" Long x 9 1/2" Outside Diam'
        ],
        options: [
            `HD1500: Arm Shield`,
            `HD1500: Arm Shield Pair`
        ],
        category: 'football',
        subCategory: 'dummies',
        urlCategory: 'football',
        urlSubCategory: 'dummies',
        image: "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fthe-club-hd1500pr-HQ1.jpg?alt=media&token=c634d899-742b-4395-a688-d4536ee63ac4",
        images: [
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fthe-club-hd1500pr-HQ1.jpg?alt=media&token=c634d899-742b-4395-a688-d4536ee63ac4",
            "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2Fthe-club-hd1500pr-HQ2.jpg?alt=media&token=dd04d929-0f67-42d3-b271-c34eee705139"
        ]
    }
]

export default productData